/**
 * Generated by orval 🍺
 * Do not edit manually.
 * nextsub Control Plane API
 * HTTP API exposed by the `nextsub` service. M5 adds usage rollups,
 * Prometheus metrics, outbox/scheduler workers, reconciliation jobs,
 * and operations runbooks on top of the M0–M4 foundation.
 *
 * OpenAPI spec version: 0.1.0-m5
 */
import type {
  AckManifestRequest,
  AdapterConfigurationResponse,
  AdapterHeartbeatRequest,
  AdapterHeartbeatResult,
  AdapterInstallReportRequest,
  AdapterInstallReportResult,
  AdapterTokenMetadata,
  AdapterTokenRotationResponse,
  AdapterTokenWithSecret,
  AdapterTrafficReportRequest,
  AdapterTrafficReportResult,
  AdapterUserSnapshot,
  AddGlobalNodeGroupExternalNode201,
  AddGlobalNodeGroupExternalNodeRequest,
  AddGlobalNodeGroupMemberRequest,
  AdminAssignUserRoleBody,
  AdminListUserRoles200,
  AdminListUsersParams,
  AdminUserCreateRequest,
  Agent,
  AgentAssignment,
  AgentAssignmentManifest,
  AgentAssignmentResult,
  AgentCreateRequest,
  AgentHeartbeatRequest,
  AgentHeartbeatResult,
  AgentInstallReportRequest,
  AgentInstallReportResult,
  AgentManagedNodeCreateRequest,
  AgentManagedNodeCreateResult,
  AgentMigrationApplyRequest,
  AgentMigrationPreview,
  AgentMigrationPreviewRequest,
  AgentMigrationResult,
  AgentProvisioningBundleResponse,
  AgentReassignNodeRequest,
  AgentTokenCreateRequest,
  AgentTokenMetadata,
  AgentTokenWithSecret,
  AgentUnassignNodeRequest,
  AgentUpdateRequest,
  Announcement,
  AnnouncementRequest,
  ApplyTenantDistributionPackage200,
  AuditLogList,
  AuthLoginRequest,
  AuthRefreshRequest,
  AuthTokenPair,
  AvailableNode,
  ChangeMyPasswordBody,
  CloseBootSessionRequest,
  CreateAdapterTokenRequest,
  CreateGrantRequest,
  CreateManagedSubscriptionRequest,
  CreateSecurityDenyRequest,
  CreateSubscriptionLinkRequest,
  CreateTenantNodeGroupRequest,
  CreateUserCredentialRequest,
  CredentialDomain,
  CredentialDomainRequest,
  DeleteExternalNode200,
  DeleteExternalSubscription200,
  DeleteTrafficRoutingPolicyParams,
  EnrollmentToken,
  EnrollmentTokenActionRequest,
  EnrollmentTokenCreateRequest,
  ExternalNode,
  ExternalNodeCreateRequest,
  ExternalNodeList,
  ExternalNodeUpdateRequest,
  ExternalSubscription,
  ExternalSubscriptionCreateRequest,
  ExternalSubscriptionList,
  ExternalSubscriptionNodeList,
  ExternalSubscriptionSyncResult,
  ExternalSubscriptionUpdateRequest,
  GetAdminTrafficParams,
  GetAdminTrafficRankingsParams,
  GetMyNotificationUnreadCount200,
  GetMyTrafficParams,
  GetMyTrafficRankingsParams,
  GetSubscriptionConfigParams,
  GetTenantTrafficParams,
  GetTenantTrafficRankingsParams,
  GetTrafficRoutingPolicyParams,
  GlobalNodeGroup,
  GlobalNodeGroupMember,
  GlobalNodeGroupUpsertRequest,
  GlobalRoutingPolicy,
  GlobalRoutingPolicyPreflightResponse,
  GlobalRoutingPolicyRequest,
  Grant,
  HealthStatus,
  HeartbeatRequest,
  IngestResponse,
  IssuedEnrollmentToken,
  LeaseGrant,
  ListAnnouncementsParams,
  ListAuditLogsParams,
  ListExternalSubscriptionNodesParams,
  ListGrantsParams,
  ListNodesParams,
  ListRoutingResourceVersionsParams,
  ListRoutingResourcesParams,
  ListTenantUsageParams,
  ListTrafficRoutingPoliciesParams,
  ListTrafficRoutingPolicyUserReferencesParams,
  ListTrafficRoutingPolicyVersionsParams,
  ManagedSubscription,
  ManifestResponse,
  MarkAllMyNotificationsRead200,
  MeProfileUpdateRequest,
  MeResponse,
  MeSubscriptionLink,
  MeUsage,
  Node,
  NodeCreateRequest,
  NodeDefaultRoutePreflightRequest,
  NodeDefaultRoutePreflightResponse,
  NodeList,
  NodeRoutingStatusResponse,
  NodeUpdateRequest,
  NotificationItem,
  OperatorUserList,
  Package,
  PackageDetail,
  PackagePreviewNodeList,
  PackageRequest,
  PatchSubscriptionLinkRequest,
  PreviewPackageNodesParams,
  ProvisioningBundleRequest,
  ProvisioningBundleResponse,
  PublicTrafficRankingSnapshot,
  PublishedPackageDetail,
  ReachableNode,
  RejectCidrList,
  RejectCidrListCreateRequest,
  RejectCidrListList,
  RejectCidrListUpdateRequest,
  RemoveGlobalNodeGroupExternalNode200,
  ReplaceInboundSelectionsRequest,
  RollbackTrafficRoutingPolicyParams,
  RotateAdapterTokenRequest,
  RoutingExternalResource,
  RoutingExternalResourceCreateRequest,
  RoutingExternalResourceList,
  RoutingExternalResourceUpdateRequest,
  RoutingExternalResourceVersionList,
  SecurityDeny,
  SingBoxSubscriptionConfig,
  SubscriptionLink,
  SubscriptionSummary,
  Tenant,
  TenantDistributionEntitlement,
  TenantID,
  TenantNodeGroup,
  TenantNodeGroupMember,
  TenantNodeGroupView,
  TenantOnboardRequest,
  TenantOnboardResult,
  TenantPackageRequest,
  TenantPromotionRequest,
  TenantUpsertRequest,
  TrafficHistory,
  TrafficRanking,
  TrafficRoutingPolicy,
  TrafficRoutingPolicyCreateRequest,
  TrafficRoutingPolicyList,
  TrafficRoutingPolicyPreflightRequest,
  TrafficRoutingPolicyPreflightResponse,
  TrafficRoutingPolicyRollbackRequest,
  TrafficRoutingPolicyUpdateRequest,
  TrafficRoutingPolicyUserReferencesResponse,
  TrafficRoutingPolicyVersionList,
  UpdateGlobalNodeGroupMemberRequest,
  UpdateGrantRequest,
  UpdateSecurityDenyRequest,
  UpdateTrafficRoutingPolicyParams,
  UsageReportIngestRequest,
  UsageRollupList,
  User,
  UserAccess,
  UserCreateRequest,
  UserCredential,
  UserListItem,
  UserManagerUpdateRequest,
  UserUpdateRequest,
  Uuid,
  VisibleSubscriptionConfig
} from './models';

import { request } from '../request';
export const getGetLivenessUrl = () => {




  return `/health/live`
}

/**
 * @summary Liveness probe
 */
export const getLiveness = async ( options?: Parameters<typeof request>[1]): Promise<HealthStatus> => {

  return request<HealthStatus>(getGetLivenessUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getGetReadinessUrl = () => {




  return `/health/ready`
}

/**
 * @summary Readiness probe
 */
export const getReadiness = async ( options?: Parameters<typeof request>[1]): Promise<HealthStatus> => {

  return request<HealthStatus>(getGetReadinessUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getGetInstallScriptUrl = () => {




  return `/install.sh`
}

/**
 * Public shell script used by provisioning install commands:
 *
 *   curl -fsSL https://panel.example/install.sh \
 *     | ADAPTER_TOKEN='nt_...' sh -s -- --node-id <uuid>
 *
 * No authentication is required; the one-time adapter token is the
 * secret. The script installs sing-box-panel-adapter, writes config,
 * posts install-report, and enables the systemd unit.
 * @summary Download the node adapter bootstrap installer.
 */
export const getInstallScript = async ( options?: Parameters<typeof request>[1]): Promise<string> => {

  return request<string>(getGetInstallScriptUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getGetAPIInstallScriptUrl = () => {




  return `/api/install.sh`
}

/**
 * Public shell script used by provisioning install commands:
 *
 *   curl -fsSL https://panel.example/install.sh \
 *     | ADAPTER_TOKEN='nt_...' sh -s -- --node-id <uuid>
 *
 * No authentication is required; the one-time adapter token is the
 * secret. The script installs sing-box-panel-adapter, writes config,
 * posts install-report, and enables the systemd unit.
 * @summary Download the node adapter bootstrap installer.
 */
export const getAPIInstallScript = async ( options?: Parameters<typeof request>[1]): Promise<string> => {

  return request<string>(getGetAPIInstallScriptUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getLoginUrl = () => {




  return `/api/v1/auth/login`
}

/**
 * @summary Exchange user credentials for an access token and refresh token.
 */
export const login = async (authLoginRequest: AuthLoginRequest, options?: Parameters<typeof request>[1]): Promise<AuthTokenPair> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<AuthTokenPair>(getLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(authLoginRequest)
  }
);}



export const getGetPublicTrafficRankingSnapshotUrl = (snapshotId: Uuid,) => {




  return `/api/v1/public/traffic-ranking-snapshots/${snapshotId}`
}

/**
 * Public capability-link endpoint used by the `/rank?uuid=...` page.
 * The payload contains display names and raw byte totals only; internal
 * user and node identifiers are deliberately omitted.
 * @summary Resolve a Telegram daily traffic ranking snapshot.
 */
export const getPublicTrafficRankingSnapshot = async (snapshotId: Uuid, options?: Parameters<typeof request>[1]): Promise<PublicTrafficRankingSnapshot> => {

  return request<PublicTrafficRankingSnapshot>(getGetPublicTrafficRankingSnapshotUrl(snapshotId),
  {
    ...options,
    method: 'GET'


  }
);}



export const getRefreshSessionUrl = () => {




  return `/api/v1/auth/refresh`
}

/**
 * @summary Rotate a refresh session and issue a new token pair.
 */
export const refreshSession = async (authRefreshRequest: AuthRefreshRequest, options?: Parameters<typeof request>[1]): Promise<AuthTokenPair> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<AuthTokenPair>(getRefreshSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(authRefreshRequest)
  }
);}



export const getLogoutSessionUrl = () => {




  return `/api/v1/auth/logout`
}

/**
 * @summary Revoke a refresh session.
 */
export const logoutSession = async (authRefreshRequest: AuthRefreshRequest, options?: Parameters<typeof request>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<void>(getLogoutSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(authRefreshRequest)
  }
);}



export const getGetCurrentPrincipalUrl = () => {




  return `/api/v1/me`
}

/**
 * @summary Return the authenticated user's self-scoped profile and roles.
 */
export const getCurrentPrincipal = async ( options?: Parameters<typeof request>[1]): Promise<MeResponse> => {

  return request<MeResponse>(getGetCurrentPrincipalUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getListMySubscriptionLinksUrl = () => {




  return `/api/v1/me/subscription-links`
}

/**
 * @summary List the authenticated user's tenant-scoped subscription links with import URLs.
 */
export const listMySubscriptionLinks = async ( options?: Parameters<typeof request>[1]): Promise<MeSubscriptionLink[]> => {

  return request<MeSubscriptionLink[]>(getListMySubscriptionLinksUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getUpdateMyProfileUrl = () => {




  return `/api/v1/me/profile`
}

/**
 * @summary Update the authenticated user's self-scoped profile.
 */
export const updateMyProfile = async (meProfileUpdateRequest: MeProfileUpdateRequest, options?: Parameters<typeof request>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<void>(getUpdateMyProfileUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(meProfileUpdateRequest)
  }
);}



export const getChangeMyPasswordUrl = () => {




  return `/api/v1/me/password`
}

/**
 * @summary Change the authenticated user's password.
 */
export const changeMyPassword = async (changeMyPasswordBody: ChangeMyPasswordBody, options?: Parameters<typeof request>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<void>(getChangeMyPasswordUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(changeMyPasswordBody)
  }
);}



export const getResetMySubscriptionUrl = () => {




  return `/api/v1/me/subscription-links/reset`
}

/**
 * Rotates subscription link secrets and all active node credentials. Existing devices must re-import the returned subscription URL.
 * @summary Reset the authenticated user's subscription and node credentials.
 */
export const resetMySubscription = async ( options?: Parameters<typeof request>[1]): Promise<MeSubscriptionLink[]> => {

  return request<MeSubscriptionLink[]>(getResetMySubscriptionUrl(),
  {
    ...options,
    method: 'POST'


  }
);}



export const getGetMyUsageUrl = () => {




  return `/api/v1/me/usage`
}

/**
 * @summary Return the authenticated tenant's current subscription usage aggregate.
 */
export const getMyUsage = async ( options?: Parameters<typeof request>[1]): Promise<MeUsage> => {

  return request<MeUsage>(getGetMyUsageUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getResetMyTrafficUrl = () => {




  return `/api/v1/me/traffic/reset`
}

/**
 * Resets the current period when usage has reached at least 80% of a finite package quota. Historical traffic records are preserved.
 * @summary Reset the authenticated user's current billable traffic period.
 */
export const resetMyTraffic = async ( options?: Parameters<typeof request>[1]): Promise<void> => {

  return request<void>(getResetMyTrafficUrl(),
  {
    ...options,
    method: 'POST'


  }
);}



export const getGetMyTrafficUrl = (params?: GetMyTrafficParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/me/traffic?${stringifiedParams}` : `/api/v1/me/traffic`
}

/**
 * @summary Return the authenticated user's raw hourly traffic history.
 */
export const getMyTraffic = async (params?: GetMyTrafficParams, options?: Parameters<typeof request>[1]): Promise<TrafficHistory> => {

  return request<TrafficHistory>(getGetMyTrafficUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export const getGetMyTrafficRankingsUrl = (params: GetMyTrafficRankingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/me/traffic/rankings?${stringifiedParams}` : `/api/v1/me/traffic/rankings`
}

/**
 * @summary Rank nodes by raw traffic for the authenticated user.
 */
export const getMyTrafficRankings = async (params: GetMyTrafficRankingsParams, options?: Parameters<typeof request>[1]): Promise<TrafficRanking> => {

  return request<TrafficRanking>(getGetMyTrafficRankingsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export const getListMyNodesUrl = () => {




  return `/api/v1/me/nodes`
}

/**
 * @summary List nodes reachable through the authenticated tenant's active subscription links.
 */
export const listMyNodes = async ( options?: Parameters<typeof request>[1]): Promise<ReachableNode[]> => {

  return request<ReachableNode[]>(getListMyNodesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getListMyCredentialsUrl = () => {




  return `/api/v1/me/credentials`
}

/**
 * @summary List the authenticated user's own credentials.
 */
export const listMyCredentials = async ( options?: Parameters<typeof request>[1]): Promise<UserCredential[]> => {

  return request<UserCredential[]>(getListMyCredentialsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getListMyNotificationsUrl = () => {




  return `/api/v1/me/notifications`
}

/**
 * @summary List recent visible announcements for the authenticated user.
 */
export const listMyNotifications = async ( options?: Parameters<typeof request>[1]): Promise<NotificationItem[]> => {

  return request<NotificationItem[]>(getListMyNotificationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getGetMyNotificationUnreadCountUrl = () => {




  return `/api/v1/me/notifications/unread-count`
}

/**
 * @summary Count unread visible announcements.
 */
export const getMyNotificationUnreadCount = async ( options?: Parameters<typeof request>[1]): Promise<GetMyNotificationUnreadCount200> => {

  return request<GetMyNotificationUnreadCount200>(getGetMyNotificationUnreadCountUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getMarkAllMyNotificationsReadUrl = () => {




  return `/api/v1/me/notifications/read-all`
}

/**
 * @summary Mark all currently visible announcements as read.
 */
export const markAllMyNotificationsRead = async ( options?: Parameters<typeof request>[1]): Promise<MarkAllMyNotificationsRead200> => {

  return request<MarkAllMyNotificationsRead200>(getMarkAllMyNotificationsReadUrl(),
  {
    ...options,
    method: 'POST'


  }
);}



export const getMarkMyNotificationReadUrl = (announcementID: string,) => {




  return `/api/v1/me/notifications/${announcementID}/read`
}

/**
 * @summary Mark one announcement as read.
 */
export const markMyNotificationRead = async (announcementID: string, options?: Parameters<typeof request>[1]): Promise<void> => {

  return request<void>(getMarkMyNotificationReadUrl(announcementID),
  {
    ...options,
    method: 'POST'


  }
);}



export const getListTenantsUrl = () => {




  return `/api/v1/tenants`
}

/**
 * @summary List tenants.
 */
export const listTenants = async ( options?: Parameters<typeof request>[1]): Promise<Tenant[]> => {

  return request<Tenant[]>(getListTenantsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getCreateTenantUrl = () => {




  return `/api/v1/tenants`
}

/**
 * @summary Create a tenant.
 */
export const createTenant = async (tenantUpsertRequest: TenantUpsertRequest, options?: Parameters<typeof request>[1]): Promise<Tenant> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<Tenant>(getCreateTenantUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(tenantUpsertRequest)
  }
);}



export const getGetTenantUrl = (tenantId: string,) => {




  return `/api/v1/tenants/${tenantId}`
}

/**
 * @summary Fetch one tenant.
 */
export const getTenant = async (tenantId: string, options?: Parameters<typeof request>[1]): Promise<Tenant> => {

  return request<Tenant>(getGetTenantUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);}



export const getUpdateTenantUrl = (tenantId: string,) => {




  return `/api/v1/tenants/${tenantId}`
}

/**
 * @summary Update a tenant.
 */
export const updateTenant = async (tenantId: string,
    tenantUpsertRequest: TenantUpsertRequest, options?: Parameters<typeof request>[1]): Promise<Tenant> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<Tenant>(getUpdateTenantUrl(tenantId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(tenantUpsertRequest)
  }
);}



export const getDeleteTenantUrl = (tenantId: string,) => {




  return `/api/v1/tenants/${tenantId}`
}

/**
 * @summary Disable a tenant.
 */
export const deleteTenant = async (tenantId: string, options?: Parameters<typeof request>[1]): Promise<void> => {

  return request<void>(getDeleteTenantUrl(tenantId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export const getListUsersUrl = (tenantId: string,) => {




  return `/api/v1/tenants/${tenantId}/users`
}

/**
 * @summary List users in a tenant.
 */
export const listUsers = async (tenantId: string, options?: Parameters<typeof request>[1]): Promise<UserListItem[]> => {

  return request<UserListItem[]>(getListUsersUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);}



export const getCreateUserUrl = (tenantId: string,) => {




  return `/api/v1/tenants/${tenantId}/users`
}

/**
 * @summary Create a user in a tenant.
 */
export const createUser = async (tenantId: string,
    userCreateRequest: UserCreateRequest, options?: Parameters<typeof request>[1]): Promise<User> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<User>(getCreateUserUrl(tenantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(userCreateRequest)
  }
);}



export const getGetUserUrl = (tenantId: string,
    userId: string,) => {




  return `/api/v1/tenants/${tenantId}/users/${userId}`
}

/**
 * @summary Fetch one user.
 */
export const getUser = async (tenantId: string,
    userId: string, options?: Parameters<typeof request>[1]): Promise<User> => {

  return request<User>(getGetUserUrl(tenantId,userId),
  {
    ...options,
    method: 'GET'


  }
);}



export const getUpdateUserUrl = (tenantId: string,
    userId: string,) => {




  return `/api/v1/tenants/${tenantId}/users/${userId}`
}

/**
 * @summary Update one user.
 */
export const updateUser = async (tenantId: string,
    userId: string,
    userUpdateRequest: UserUpdateRequest, options?: Parameters<typeof request>[1]): Promise<User> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<User>(getUpdateUserUrl(tenantId,userId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(userUpdateRequest)
  }
);}



export const getDeleteUserUrl = (tenantId: string,
    userId: string,) => {




  return `/api/v1/tenants/${tenantId}/users/${userId}`
}

/**
 * Super-admins may delete any non-self user in tenant scope. Tenant
 * administrators may delete only users assigned to them. User-owned
 * access, credential, routing, link, and management data is removed;
 * subscriptions are cancelled and anonymized. Immutable billing ledger
 * and audit history remain without a users foreign-key relationship.
 * @summary Permanently delete a user and their deletable data.
 */
export const deleteUser = async (tenantId: string,
    userId: string, options?: Parameters<typeof request>[1]): Promise<void> => {

  return request<void>(getDeleteUserUrl(tenantId,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export const getEnableUserUrl = (tenantId: string,
    userId: string,) => {




  return `/api/v1/tenants/${tenantId}/users/${userId}/enable`
}

/**
 * @summary Enable one user.
 */
export const enableUser = async (tenantId: string,
    userId: string, options?: Parameters<typeof request>[1]): Promise<User> => {

  return request<User>(getEnableUserUrl(tenantId,userId),
  {
    ...options,
    method: 'PUT'


  }
);}



export const getDisableUserUrl = (tenantId: string,
    userId: string,) => {




  return `/api/v1/tenants/${tenantId}/users/${userId}/disable`
}

/**
 * @summary Disable one user.
 */
export const disableUser = async (tenantId: string,
    userId: string, options?: Parameters<typeof request>[1]): Promise<User> => {

  return request<User>(getDisableUserUrl(tenantId,userId),
  {
    ...options,
    method: 'PUT'


  }
);}



export const getAdminListTenantAssignablePackagesUrl = (tenantId: string,) => {




  return `/admin/v1/tenants/${tenantId}/packages`
}

/**
 * @summary List packages assignable to a tenant user (super-admin).
 */
export const adminListTenantAssignablePackages = async (tenantId: string, options?: Parameters<typeof request>[1]): Promise<Package[]> => {

  return request<Package[]>(getAdminListTenantAssignablePackagesUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);}



export const getAdminListTenantSubscriptionsUrl = (tenantId: string,) => {




  return `/admin/v1/tenants/${tenantId}/subscriptions`
}

/**
 * @summary List subscriptions for a tenant (super-admin).
 */
export const adminListTenantSubscriptions = async (tenantId: string, options?: Parameters<typeof request>[1]): Promise<SubscriptionSummary[]> => {

  return request<SubscriptionSummary[]>(getAdminListTenantSubscriptionsUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);}



export const getAdminCreateTenantSubscriptionUrl = (tenantId: string,) => {




  return `/admin/v1/tenants/${tenantId}/subscriptions`
}

/**
 * Reassigning an active user preserves current subscription-link identity and node credentials while replacing package-derived access.
 * @summary Create a managed subscription for a tenant user (super-admin).
 */
export const adminCreateTenantSubscription = async (tenantId: string,
    createManagedSubscriptionRequest: CreateManagedSubscriptionRequest, options?: Parameters<typeof request>[1]): Promise<ManagedSubscription> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<ManagedSubscription>(getAdminCreateTenantSubscriptionUrl(tenantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createManagedSubscriptionRequest)
  }
);}



export const getAdminCancelTenantSubscriptionUrl = (tenantId: string,
    subscriptionID: Uuid,) => {




  return `/admin/v1/tenants/${tenantId}/subscriptions/${subscriptionID}/cancel`
}

/**
 * @summary Cancel a tenant subscription (super-admin).
 */
export const adminCancelTenantSubscription = async (tenantId: string,
    subscriptionID: Uuid, options?: Parameters<typeof request>[1]): Promise<void> => {

  return request<void>(getAdminCancelTenantSubscriptionUrl(tenantId,subscriptionID),
  {
    ...options,
    method: 'POST'


  }
);}



export const getAdminGetTenantUserAccessUrl = (tenantId: string,
    userId: string,) => {




  return `/admin/v1/tenants/${tenantId}/users/${userId}/access`
}

/**
 * @summary Read subscription links, passwords, usage, and expiry for a tenant user.
 */
export const adminGetTenantUserAccess = async (tenantId: string,
    userId: string, options?: Parameters<typeof request>[1]): Promise<UserAccess> => {

  return request<UserAccess>(getAdminGetTenantUserAccessUrl(tenantId,userId),
  {
    ...options,
    method: 'GET'


  }
);}



export const getAdminResetTenantUserSubscriptionUrl = (tenantId: string,
    userId: string,) => {




  return `/admin/v1/tenants/${tenantId}/users/${userId}/subscription/reset`
}

/**
 * @summary Rotate a tenant user's subscription links and node credentials.
 */
export const adminResetTenantUserSubscription = async (tenantId: string,
    userId: string, options?: Parameters<typeof request>[1]): Promise<UserAccess> => {

  return request<UserAccess>(getAdminResetTenantUserSubscriptionUrl(tenantId,userId),
  {
    ...options,
    method: 'POST'


  }
);}



export const getAdminResetTenantUserTrafficUrl = (tenantId: string,
    userId: string,) => {




  return `/admin/v1/tenants/${tenantId}/users/${userId}/traffic/reset`
}

/**
 * @summary Reset a tenant user's current billable traffic period.
 */
export const adminResetTenantUserTraffic = async (tenantId: string,
    userId: string, options?: Parameters<typeof request>[1]): Promise<void> => {

  return request<void>(getAdminResetTenantUserTrafficUrl(tenantId,userId),
  {
    ...options,
    method: 'POST'


  }
);}



export const getOnboardTenantUrl = () => {




  return `/admin/v1/tenants/onboard`
}

/**
 * @summary Create a tenant and its first tenant-admin user atomically.
 */
export const onboardTenant = async (tenantOnboardRequest: TenantOnboardRequest, options?: Parameters<typeof request>[1]): Promise<TenantOnboardResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<TenantOnboardResult>(getOnboardTenantUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(tenantOnboardRequest)
  }
);}



export const getAdminListTenantUsersUrl = (tenantId: string,) => {




  return `/admin/v1/tenants/${tenantId}/users`
}

/**
 * @summary List users in a tenant (super-admin).
 */
export const adminListTenantUsers = async (tenantId: string, options?: Parameters<typeof request>[1]): Promise<UserListItem[]> => {

  return request<UserListItem[]>(getAdminListTenantUsersUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);}



export const getAdminCreateTenantUserUrl = (tenantId: string,) => {




  return `/admin/v1/tenants/${tenantId}/users`
}

/**
 * @summary Create a user in a tenant (super-admin).
 */
export const adminCreateTenantUser = async (tenantId: string,
    adminUserCreateRequest: AdminUserCreateRequest, options?: Parameters<typeof request>[1]): Promise<User> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<User>(getAdminCreateTenantUserUrl(tenantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminUserCreateRequest)
  }
);}



export const getAdminPromoteUserToTenantUrl = (tenantId: string,
    userId: string,) => {




  return `/admin/v1/tenants/${tenantId}/users/${userId}/promote-to-tenant`
}

/**
 * Super-admin only. The path tenant_id must be the authenticated
 * principal's current tenant. The source user must be active, tenant-
 * direct, have no managed users, and have no IAM, billing, credential,
 * or routing references. The operation is atomic and invalidates the
 * user's existing access and refresh sessions.
 * @summary Move an eligible tenant-direct user into a new tenant as its first tenant-admin.
 */
export const adminPromoteUserToTenant = async (tenantId: string,
    userId: string,
    tenantPromotionRequest: TenantPromotionRequest, options?: Parameters<typeof request>[1]): Promise<TenantOnboardResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<TenantOnboardResult>(getAdminPromoteUserToTenantUrl(tenantId,userId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(tenantPromotionRequest)
  }
);}



export const getAdminListUsersUrl = (params?: AdminListUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/v1/users?${stringifiedParams}` : `/admin/v1/users`
}

/**
 * @summary List users across all tenants with their current management assignment.
 */
export const adminListUsers = async (params?: AdminListUsersParams, options?: Parameters<typeof request>[1]): Promise<OperatorUserList> => {

  return request<OperatorUserList>(getAdminListUsersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export const getAdminSetUserManagerUrl = (tenantId: string,
    userId: Uuid,) => {




  return `/admin/v1/tenants/${tenantId}/users/${userId}/manager`
}

/**
 * @summary Assign a user to a tenant administrator or make the user tenant-direct.
 */
export const adminSetUserManager = async (tenantId: string,
    userId: Uuid,
    userManagerUpdateRequest: UserManagerUpdateRequest, options?: Parameters<typeof request>[1]): Promise<UserListItem> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<UserListItem>(getAdminSetUserManagerUrl(tenantId,userId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(userManagerUpdateRequest)
  }
);}



export const getAdminListUserRolesUrl = (tenantId: string,
    userId: Uuid,) => {




  return `/admin/v1/tenants/${tenantId}/users/${userId}/roles`
}

/**
 * @summary List mapped roles for a tenant user.
 */
export const adminListUserRoles = async (tenantId: string,
    userId: Uuid, options?: Parameters<typeof request>[1]): Promise<AdminListUserRoles200> => {

  return request<AdminListUserRoles200>(getAdminListUserRolesUrl(tenantId,userId),
  {
    ...options,
    method: 'GET'


  }
);}



export const getAdminAssignUserRoleUrl = (tenantId: string,
    userId: Uuid,) => {




  return `/admin/v1/tenants/${tenantId}/users/${userId}/roles`
}

/**
 * @summary Grant tenant_admin to a user.
 */
export const adminAssignUserRole = async (tenantId: string,
    userId: Uuid,
    adminAssignUserRoleBody: AdminAssignUserRoleBody, options?: Parameters<typeof request>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<void>(getAdminAssignUserRoleUrl(tenantId,userId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminAssignUserRoleBody)
  }
);}



export const getAdminRevokeTenantAdminUrl = (tenantId: string,
    userId: Uuid,) => {




  return `/admin/v1/tenants/${tenantId}/users/${userId}/roles/tenant_admin`
}

/**
 * @summary Revoke tenant_admin from a user (cannot remove last admin).
 */
export const adminRevokeTenantAdmin = async (tenantId: string,
    userId: Uuid, options?: Parameters<typeof request>[1]): Promise<void> => {

  return request<void>(getAdminRevokeTenantAdminUrl(tenantId,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export const getListNodesUrl = (params?: ListNodesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/v1/nodes?${stringifiedParams}` : `/admin/v1/nodes`
}

/**
 * @summary List virtual nodes.
 */
export const listNodes = async (params?: ListNodesParams, options?: Parameters<typeof request>[1]): Promise<NodeList> => {

  return request<NodeList>(getListNodesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export const getCreateNodeUrl = () => {




  return `/admin/v1/nodes`
}

/**
 * @summary Create a virtual node.
 */
export const createNode = async (nodeCreateRequest: NodeCreateRequest, options?: Parameters<typeof request>[1]): Promise<Node> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<Node>(getCreateNodeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(nodeCreateRequest)
  }
);}



export const getGetNodeUrl = (nodeID: string,) => {




  return `/admin/v1/nodes/${nodeID}`
}

/**
 * @summary Fetch one virtual node.
 */
export const getNode = async (nodeID: string, options?: Parameters<typeof request>[1]): Promise<Node> => {

  return request<Node>(getGetNodeUrl(nodeID),
  {
    ...options,
    method: 'GET'


  }
);}



export const getUpdateNodeUrl = (nodeID: string,) => {




  return `/admin/v1/nodes/${nodeID}`
}

/**
 * @summary Update a virtual node.
 */
export const updateNode = async (nodeID: string,
    nodeUpdateRequest: NodeUpdateRequest, options?: Parameters<typeof request>[1]): Promise<Node> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<Node>(getUpdateNodeUrl(nodeID),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(nodeUpdateRequest)
  }
);}



export const getDeleteNodeUrl = (nodeID: string,) => {




  return `/admin/v1/nodes/${nodeID}`
}

/**
 * Physically removes a virtual node. Grants, subscription associations,
 * runtime bindings, closed boot sessions, and adapter tokens are cleaned
 * automatically. Plan-version membership and active boot sessions
 * remain protected; when either references the node, the call returns a
 * 409 conflict envelope whose `details` payload names the blocking tables
 * in `referenced_by`.
 * @summary Delete a virtual node.
 */
export const deleteNode = async (nodeID: string, options?: Parameters<typeof request>[1]): Promise<void> => {

  return request<void>(getDeleteNodeUrl(nodeID),
  {
    ...options,
    method: 'DELETE'


  }
);}



export const getCreateProvisioningBundleUrl = () => {




  return `/admin/v1/nodes/provisioning-bundles`
}

/**
 * @summary Create a virtual node with a one-click provisioning bundle.
 */
export const createProvisioningBundle = async (provisioningBundleRequest: ProvisioningBundleRequest, options?: Parameters<typeof request>[1]): Promise<ProvisioningBundleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<ProvisioningBundleResponse>(getCreateProvisioningBundleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(provisioningBundleRequest)
  }
);}



export const getReissueProvisioningBundleUrl = (nodeID: string,) => {




  return `/admin/v1/nodes/${nodeID}/provisioning-bundles`
}

/**
 * Mints a new one-time adapter token and install command for a node that
 * already exists. Does not create another node row.
 * @summary Re-issue install bundle for an existing virtual node.
 */
export const reissueProvisioningBundle = async (nodeID: string, options?: Parameters<typeof request>[1]): Promise<ProvisioningBundleResponse> => {

  return request<ProvisioningBundleResponse>(getReissueProvisioningBundleUrl(nodeID),
  {
    ...options,
    method: 'POST'


  }
);}



export const getListRoutingResourcesUrl = (params?: ListRoutingResourcesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/v1/routing-resources?${stringifiedParams}` : `/admin/v1/routing-resources`
}

/**
 * @summary List reusable routing resources.
 */
export const listRoutingResources = async (params?: ListRoutingResourcesParams, options?: Parameters<typeof request>[1]): Promise<RoutingExternalResourceList> => {

  return request<RoutingExternalResourceList>(getListRoutingResourcesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export const getCreateRoutingResourceUrl = () => {




  return `/admin/v1/routing-resources`
}

/**
 * @summary Create a reusable routing resource at version 1.
 */
export const createRoutingResource = async (routingExternalResourceCreateRequest: RoutingExternalResourceCreateRequest, options?: Parameters<typeof request>[1]): Promise<RoutingExternalResource> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<RoutingExternalResource>(getCreateRoutingResourceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(routingExternalResourceCreateRequest)
  }
);}



export const getListRejectCidrListsUrl = () => {




  return `/admin/v1/reject-cidr-lists`
}

/**
 * @summary List admin-managed reject CIDR lists.
 */
export const listRejectCidrLists = async ( options?: Parameters<typeof request>[1]): Promise<RejectCidrListList> => {

  return request<RejectCidrListList>(getListRejectCidrListsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getCreateRejectCidrListUrl = () => {




  return `/admin/v1/reject-cidr-lists`
}

/**
 * @summary Create a reject CIDR list at version 1.
 */
export const createRejectCidrList = async (rejectCidrListCreateRequest: RejectCidrListCreateRequest, options?: Parameters<typeof request>[1]): Promise<RejectCidrList> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<RejectCidrList>(getCreateRejectCidrListUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(rejectCidrListCreateRequest)
  }
);}



export const getGetRejectCidrListUrl = (listID: Uuid,) => {




  return `/admin/v1/reject-cidr-lists/${listID}`
}

/**
 * @summary Get a reject CIDR list.
 */
export const getRejectCidrList = async (listID: Uuid, options?: Parameters<typeof request>[1]): Promise<RejectCidrList> => {

  return request<RejectCidrList>(getGetRejectCidrListUrl(listID),
  {
    ...options,
    method: 'GET'


  }
);}



export const getUpdateRejectCidrListUrl = (listID: Uuid,) => {




  return `/admin/v1/reject-cidr-lists/${listID}`
}

/**
 * @summary Update a reject CIDR list. Every node selecting it receives a new configuration revision. Built-in lists return 403.
 */
export const updateRejectCidrList = async (listID: Uuid,
    rejectCidrListUpdateRequest: RejectCidrListUpdateRequest, options?: Parameters<typeof request>[1]): Promise<RejectCidrList> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<RejectCidrList>(getUpdateRejectCidrListUrl(listID),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(rejectCidrListUpdateRequest)
  }
);}



export const getDeleteRejectCidrListUrl = (listID: Uuid,) => {




  return `/admin/v1/reject-cidr-lists/${listID}`
}

/**
 * @summary Delete a reject CIDR list. Blocked with 409 conflict while any node selects it; details carry referenced_by ["nodes"] and node_ids. Built-in lists return 403.
 */
export const deleteRejectCidrList = async (listID: Uuid, options?: Parameters<typeof request>[1]): Promise<void> => {

  return request<void>(getDeleteRejectCidrListUrl(listID),
  {
    ...options,
    method: 'DELETE'


  }
);}



export const getGetGlobalRoutingPolicyUrl = () => {




  return `/admin/v1/global-routing-policy`
}

/**
 * @summary Get the single panel-wide default sing-box route.
 */
export const getGlobalRoutingPolicy = async ( options?: Parameters<typeof request>[1]): Promise<GlobalRoutingPolicy> => {

  return request<GlobalRoutingPolicy>(getGetGlobalRoutingPolicyUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getPublishGlobalRoutingPolicyUrl = () => {




  return `/admin/v1/global-routing-policy`
}

/**
 * Performs an authoritative all-node preview before atomically advancing the global route version.
 * @summary Publish one route that every current and future node inherits.
 */
export const publishGlobalRoutingPolicy = async (globalRoutingPolicyRequest: GlobalRoutingPolicyRequest, options?: Parameters<typeof request>[1]): Promise<GlobalRoutingPolicy> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<GlobalRoutingPolicy>(getPublishGlobalRoutingPolicyUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(globalRoutingPolicyRequest)
  }
);}



export const getPreflightGlobalRoutingPolicyUrl = () => {




  return `/admin/v1/global-routing-policy/preflight`
}

/**
 * @summary Compile a global route candidate against every node.
 */
export const preflightGlobalRoutingPolicy = async (globalRoutingPolicyRequest: GlobalRoutingPolicyRequest, options?: Parameters<typeof request>[1]): Promise<GlobalRoutingPolicyPreflightResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<GlobalRoutingPolicyPreflightResponse>(getPreflightGlobalRoutingPolicyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(globalRoutingPolicyRequest)
  }
);}



export const getGetRoutingResourceUrl = (resourceID: Uuid,) => {




  return `/admin/v1/routing-resources/${resourceID}`
}

/**
 * @summary Get the current routing resource version.
 */
export const getRoutingResource = async (resourceID: Uuid, options?: Parameters<typeof request>[1]): Promise<RoutingExternalResource> => {

  return request<RoutingExternalResource>(getGetRoutingResourceUrl(resourceID),
  {
    ...options,
    method: 'GET'


  }
);}



export const getUpdateRoutingResourceUrl = (resourceID: Uuid,) => {




  return `/admin/v1/routing-resources/${resourceID}`
}

/**
 * @summary Create a new immutable version and update catalog metadata.
 */
export const updateRoutingResource = async (resourceID: Uuid,
    routingExternalResourceUpdateRequest: RoutingExternalResourceUpdateRequest, options?: Parameters<typeof request>[1]): Promise<RoutingExternalResource> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<RoutingExternalResource>(getUpdateRoutingResourceUrl(resourceID),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(routingExternalResourceUpdateRequest)
  }
);}



export const getListRoutingResourceVersionsUrl = (resourceID: Uuid,
    params?: ListRoutingResourceVersionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/v1/routing-resources/${resourceID}/versions?${stringifiedParams}` : `/admin/v1/routing-resources/${resourceID}/versions`
}

/**
 * @summary List immutable routing resource versions.
 */
export const listRoutingResourceVersions = async (resourceID: Uuid,
    params?: ListRoutingResourceVersionsParams, options?: Parameters<typeof request>[1]): Promise<RoutingExternalResourceVersionList> => {

  return request<RoutingExternalResourceVersionList>(getListRoutingResourceVersionsUrl(resourceID,params),
  {
    ...options,
    method: 'GET'


  }
);}



export const getListExternalNodesUrl = () => {




  return `/admin/v1/external-nodes`
}

/**
 * @summary List manually stored external nodes without exposing share links.
 */
export const listExternalNodes = async ( options?: Parameters<typeof request>[1]): Promise<ExternalNodeList> => {

  return request<ExternalNodeList>(getListExternalNodesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getCreateExternalNodeUrl = () => {




  return `/admin/v1/external-nodes`
}

/**
 * @summary Store one encrypted share link with its original display name.
 */
export const createExternalNode = async (externalNodeCreateRequest: ExternalNodeCreateRequest, options?: Parameters<typeof request>[1]): Promise<ExternalNode> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<ExternalNode>(getCreateExternalNodeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(externalNodeCreateRequest)
  }
);}



export const getGetExternalNodeUrl = (externalNodeID: Uuid,) => {




  return `/admin/v1/external-nodes/${externalNodeID}`
}

export const getExternalNode = async (externalNodeID: Uuid, options?: Parameters<typeof request>[1]): Promise<ExternalNode> => {

  return request<ExternalNode>(getGetExternalNodeUrl(externalNodeID),
  {
    ...options,
    method: 'GET'


  }
);}



export const getUpdateExternalNodeUrl = (externalNodeID: Uuid,) => {




  return `/admin/v1/external-nodes/${externalNodeID}`
}

export const updateExternalNode = async (externalNodeID: Uuid,
    externalNodeUpdateRequest: ExternalNodeUpdateRequest, options?: Parameters<typeof request>[1]): Promise<ExternalNode> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<ExternalNode>(getUpdateExternalNodeUrl(externalNodeID),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(externalNodeUpdateRequest)
  }
);}



export const getDeleteExternalNodeUrl = (externalNodeID: Uuid,) => {




  return `/admin/v1/external-nodes/${externalNodeID}`
}

/**
 * @summary Delete an external node only when no group or snapshot references it.
 */
export const deleteExternalNode = async (externalNodeID: Uuid, options?: Parameters<typeof request>[1]): Promise<DeleteExternalNode200> => {

  return request<DeleteExternalNode200>(getDeleteExternalNodeUrl(externalNodeID),
  {
    ...options,
    method: 'DELETE'


  }
);}



export const getListGlobalNodeGroupExternalNodesUrl = (groupID: Uuid,) => {




  return `/admin/v1/node-groups/${groupID}/external-nodes`
}

export const listGlobalNodeGroupExternalNodes = async (groupID: Uuid, options?: Parameters<typeof request>[1]): Promise<ExternalNodeList> => {

  return request<ExternalNodeList>(getListGlobalNodeGroupExternalNodesUrl(groupID),
  {
    ...options,
    method: 'GET'


  }
);}



export const getAddGlobalNodeGroupExternalNodeUrl = (groupID: Uuid,) => {




  return `/admin/v1/node-groups/${groupID}/external-nodes`
}

export const addGlobalNodeGroupExternalNode = async (groupID: Uuid,
    addGlobalNodeGroupExternalNodeRequest: AddGlobalNodeGroupExternalNodeRequest, options?: Parameters<typeof request>[1]): Promise<AddGlobalNodeGroupExternalNode201> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<AddGlobalNodeGroupExternalNode201>(getAddGlobalNodeGroupExternalNodeUrl(groupID),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addGlobalNodeGroupExternalNodeRequest)
  }
);}



export const getRemoveGlobalNodeGroupExternalNodeUrl = (groupID: Uuid,
    externalNodeID: Uuid,) => {




  return `/admin/v1/node-groups/${groupID}/external-nodes/${externalNodeID}`
}

export const removeGlobalNodeGroupExternalNode = async (groupID: Uuid,
    externalNodeID: Uuid, options?: Parameters<typeof request>[1]): Promise<RemoveGlobalNodeGroupExternalNode200> => {

  return request<RemoveGlobalNodeGroupExternalNode200>(getRemoveGlobalNodeGroupExternalNodeUrl(groupID,externalNodeID),
  {
    ...options,
    method: 'DELETE'


  }
);}



export const getListExternalSubscriptionsUrl = () => {




  return `/admin/v1/external-subscriptions`
}

/**
 * @summary List external subscription sources.
 */
export const listExternalSubscriptions = async ( options?: Parameters<typeof request>[1]): Promise<ExternalSubscriptionList> => {

  return request<ExternalSubscriptionList>(getListExternalSubscriptionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getCreateExternalSubscriptionUrl = () => {




  return `/admin/v1/external-subscriptions`
}

/**
 * @summary Create an encrypted external subscription source and queue its first sync.
 */
export const createExternalSubscription = async (externalSubscriptionCreateRequest: ExternalSubscriptionCreateRequest, options?: Parameters<typeof request>[1]): Promise<ExternalSubscription> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<ExternalSubscription>(getCreateExternalSubscriptionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(externalSubscriptionCreateRequest)
  }
);}



export const getGetExternalSubscriptionUrl = (subscriptionID: Uuid,) => {




  return `/admin/v1/external-subscriptions/${subscriptionID}`
}

/**
 * @summary Get one external subscription without exposing its source URL.
 */
export const getExternalSubscription = async (subscriptionID: Uuid, options?: Parameters<typeof request>[1]): Promise<ExternalSubscription> => {

  return request<ExternalSubscription>(getGetExternalSubscriptionUrl(subscriptionID),
  {
    ...options,
    method: 'GET'


  }
);}



export const getUpdateExternalSubscriptionUrl = (subscriptionID: Uuid,) => {




  return `/admin/v1/external-subscriptions/${subscriptionID}`
}

/**
 * @summary Update source settings and queue a refresh when parsing inputs change.
 */
export const updateExternalSubscription = async (subscriptionID: Uuid,
    externalSubscriptionUpdateRequest: ExternalSubscriptionUpdateRequest, options?: Parameters<typeof request>[1]): Promise<ExternalSubscription> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<ExternalSubscription>(getUpdateExternalSubscriptionUrl(subscriptionID),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(externalSubscriptionUpdateRequest)
  }
);}



export const getDeleteExternalSubscriptionUrl = (subscriptionID: Uuid,) => {




  return `/admin/v1/external-subscriptions/${subscriptionID}`
}

/**
 * @summary Delete an external subscription and its imported node inventory.
 */
export const deleteExternalSubscription = async (subscriptionID: Uuid, options?: Parameters<typeof request>[1]): Promise<DeleteExternalSubscription200> => {

  return request<DeleteExternalSubscription200>(getDeleteExternalSubscriptionUrl(subscriptionID),
  {
    ...options,
    method: 'DELETE'


  }
);}



export const getSyncExternalSubscriptionUrl = (subscriptionID: Uuid,) => {




  return `/admin/v1/external-subscriptions/${subscriptionID}/sync`
}

/**
 * A failed sync records a safe error code and preserves the previous usable inventory.
 * @summary Fetch, parse, filter, and atomically replace an external node inventory.
 */
export const syncExternalSubscription = async (subscriptionID: Uuid, options?: Parameters<typeof request>[1]): Promise<ExternalSubscriptionSyncResult> => {

  return request<ExternalSubscriptionSyncResult>(getSyncExternalSubscriptionUrl(subscriptionID),
  {
    ...options,
    method: 'POST'


  }
);}



export const getListExternalSubscriptionNodesUrl = (subscriptionID: Uuid,
    params?: ListExternalSubscriptionNodesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/v1/external-subscriptions/${subscriptionID}/nodes?${stringifiedParams}` : `/admin/v1/external-subscriptions/${subscriptionID}/nodes`
}

/**
 * @summary List safe node previews from the latest successful sync.
 */
export const listExternalSubscriptionNodes = async (subscriptionID: Uuid,
    params?: ListExternalSubscriptionNodesParams, options?: Parameters<typeof request>[1]): Promise<ExternalSubscriptionNodeList> => {

  return request<ExternalSubscriptionNodeList>(getListExternalSubscriptionNodesUrl(subscriptionID,params),
  {
    ...options,
    method: 'GET'


  }
);}



export const getPreflightNodeDefaultRouteUrl = (nodeID: string,) => {




  return `/admin/v1/nodes/${nodeID}/routing/preflight`
}

/**
 * Uses the node-owned outbound resources, current eligible users and
 * policies, and current adapter capability to produce the exact
 * secret-free route and configuration revision that would be delivered.
 * @summary Compile and validate a candidate node-default sing-box route.
 */
export const preflightNodeDefaultRoute = async (nodeID: string,
    nodeDefaultRoutePreflightRequest: NodeDefaultRoutePreflightRequest, options?: Parameters<typeof request>[1]): Promise<NodeDefaultRoutePreflightResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<NodeDefaultRoutePreflightResponse>(getPreflightNodeDefaultRouteUrl(nodeID),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(nodeDefaultRoutePreflightRequest)
  }
);}



export const getGetNodeRoutingStatusUrl = (nodeID: string,) => {




  return `/admin/v1/nodes/${nodeID}/routing/status`
}

/**
 * Returns the latest node configuration heartbeat together with the
 * current, freshness-checked user-routing capability evidence.
 * @summary Get node routing heartbeat and adapter capability status.
 */
export const getNodeRoutingStatus = async (nodeID: string, options?: Parameters<typeof request>[1]): Promise<NodeRoutingStatusResponse> => {

  return request<NodeRoutingStatusResponse>(getGetNodeRoutingStatusUrl(nodeID),
  {
    ...options,
    method: 'GET'


  }
);}



export const getListTrafficRoutingPoliciesUrl = (params: ListTrafficRoutingPoliciesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/v1/traffic-routing-policies?${stringifiedParams}` : `/admin/v1/traffic-routing-policies`
}

/**
 * @summary List tenant-scoped traffic routing policies.
 */
export const listTrafficRoutingPolicies = async (params: ListTrafficRoutingPoliciesParams, options?: Parameters<typeof request>[1]): Promise<TrafficRoutingPolicyList> => {

  return request<TrafficRoutingPolicyList>(getListTrafficRoutingPoliciesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export const getCreateTrafficRoutingPolicyUrl = () => {




  return `/admin/v1/traffic-routing-policies`
}

/**
 * @summary Create a tenant-scoped traffic routing policy.
 */
export const createTrafficRoutingPolicy = async (trafficRoutingPolicyCreateRequest: TrafficRoutingPolicyCreateRequest, options?: Parameters<typeof request>[1]): Promise<TrafficRoutingPolicy> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<TrafficRoutingPolicy>(getCreateTrafficRoutingPolicyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(trafficRoutingPolicyCreateRequest)
  }
);}



export const getGetTrafficRoutingPolicyUrl = (policyID: Uuid,
    params: GetTrafficRoutingPolicyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/v1/traffic-routing-policies/${policyID}?${stringifiedParams}` : `/admin/v1/traffic-routing-policies/${policyID}`
}

/**
 * @summary Get a traffic routing policy.
 */
export const getTrafficRoutingPolicy = async (policyID: Uuid,
    params: GetTrafficRoutingPolicyParams, options?: Parameters<typeof request>[1]): Promise<TrafficRoutingPolicy> => {

  return request<TrafficRoutingPolicy>(getGetTrafficRoutingPolicyUrl(policyID,params),
  {
    ...options,
    method: 'GET'


  }
);}



export const getUpdateTrafficRoutingPolicyUrl = (policyID: Uuid,
    params: UpdateTrafficRoutingPolicyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/v1/traffic-routing-policies/${policyID}?${stringifiedParams}` : `/admin/v1/traffic-routing-policies/${policyID}`
}

/**
 * @summary Update a traffic routing policy with optimistic concurrency.
 */
export const updateTrafficRoutingPolicy = async (policyID: Uuid,
    trafficRoutingPolicyUpdateRequest: TrafficRoutingPolicyUpdateRequest,
    params: UpdateTrafficRoutingPolicyParams, options?: Parameters<typeof request>[1]): Promise<TrafficRoutingPolicy> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<TrafficRoutingPolicy>(getUpdateTrafficRoutingPolicyUrl(policyID,params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(trafficRoutingPolicyUpdateRequest)
  }
);}



export const getDeleteTrafficRoutingPolicyUrl = (policyID: Uuid,
    params: DeleteTrafficRoutingPolicyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/v1/traffic-routing-policies/${policyID}?${stringifiedParams}` : `/admin/v1/traffic-routing-policies/${policyID}`
}

/**
 * @summary Delete a traffic routing policy with optimistic concurrency.
 */
export const deleteTrafficRoutingPolicy = async (policyID: Uuid,
    params: DeleteTrafficRoutingPolicyParams, options?: Parameters<typeof request>[1]): Promise<void> => {

  return request<void>(getDeleteTrafficRoutingPolicyUrl(policyID,params),
  {
    ...options,
    method: 'DELETE'


  }
);}



export const getListTrafficRoutingPolicyVersionsUrl = (policyID: Uuid,
    params: ListTrafficRoutingPolicyVersionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/v1/traffic-routing-policies/${policyID}/versions?${stringifiedParams}` : `/admin/v1/traffic-routing-policies/${policyID}/versions`
}

/**
 * @summary List immutable versions of a routing policy.
 */
export const listTrafficRoutingPolicyVersions = async (policyID: Uuid,
    params: ListTrafficRoutingPolicyVersionsParams, options?: Parameters<typeof request>[1]): Promise<TrafficRoutingPolicyVersionList> => {

  return request<TrafficRoutingPolicyVersionList>(getListTrafficRoutingPolicyVersionsUrl(policyID,params),
  {
    ...options,
    method: 'GET'


  }
);}



export const getRollbackTrafficRoutingPolicyUrl = (policyID: Uuid,
    params: RollbackTrafficRoutingPolicyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/v1/traffic-routing-policies/${policyID}/rollback?${stringifiedParams}` : `/admin/v1/traffic-routing-policies/${policyID}/rollback`
}

/**
 * @summary Restore a historical route as a new disabled draft version.
 */
export const rollbackTrafficRoutingPolicy = async (policyID: Uuid,
    trafficRoutingPolicyRollbackRequest: TrafficRoutingPolicyRollbackRequest,
    params: RollbackTrafficRoutingPolicyParams, options?: Parameters<typeof request>[1]): Promise<TrafficRoutingPolicy> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<TrafficRoutingPolicy>(getRollbackTrafficRoutingPolicyUrl(policyID,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(trafficRoutingPolicyRollbackRequest)
  }
);}



export const getPreflightTrafficRoutingPolicyUrl = () => {




  return `/admin/v1/traffic-routing-policies/preflight`
}

/**
 * @summary Validate a user routing fragment against all applicable nodes.
 */
export const preflightTrafficRoutingPolicy = async (trafficRoutingPolicyPreflightRequest: TrafficRoutingPolicyPreflightRequest, options?: Parameters<typeof request>[1]): Promise<TrafficRoutingPolicyPreflightResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<TrafficRoutingPolicyPreflightResponse>(getPreflightTrafficRoutingPolicyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(trafficRoutingPolicyPreflightRequest)
  }
);}



export const getListTrafficRoutingPolicyUserReferencesUrl = (params: ListTrafficRoutingPolicyUserReferencesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/v1/traffic-routing-policies/references/users?${stringifiedParams}` : `/admin/v1/traffic-routing-policies/references/users`
}

/**
 * @summary List eligible users for a tenant and node policy target.
 */
export const listTrafficRoutingPolicyUserReferences = async (params: ListTrafficRoutingPolicyUserReferencesParams, options?: Parameters<typeof request>[1]): Promise<TrafficRoutingPolicyUserReferencesResponse> => {

  return request<TrafficRoutingPolicyUserReferencesResponse>(getListTrafficRoutingPolicyUserReferencesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export const getListAgentsUrl = () => {




  return `/admin/v1/agents`
}

/**
 * @summary List adapter agents.
 */
export const listAgents = async ( options?: Parameters<typeof request>[1]): Promise<Agent[]> => {

  return request<Agent[]>(getListAgentsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getCreateAgentUrl = () => {




  return `/admin/v1/agents`
}

/**
 * @summary Create an adapter agent without installing runtime credentials.
 */
export const createAgent = async (agentCreateRequest: AgentCreateRequest, options?: Parameters<typeof request>[1]): Promise<Agent> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<Agent>(getCreateAgentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(agentCreateRequest)
  }
);}



export const getGetAgentUrl = (agentID: string,) => {




  return `/admin/v1/agents/${agentID}`
}

/**
 * @summary Fetch one adapter agent.
 */
export const getAgent = async (agentID: string, options?: Parameters<typeof request>[1]): Promise<Agent> => {

  return request<Agent>(getGetAgentUrl(agentID),
  {
    ...options,
    method: 'GET'


  }
);}



export const getUpdateAgentUrl = (agentID: string,) => {




  return `/admin/v1/agents/${agentID}`
}

/**
 * @summary Update adapter-agent name or lifecycle status.
 */
export const updateAgent = async (agentID: string,
    agentUpdateRequest: AgentUpdateRequest, options?: Parameters<typeof request>[1]): Promise<Agent> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<Agent>(getUpdateAgentUrl(agentID),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(agentUpdateRequest)
  }
);}



export const getDeleteAgentUrl = (agentID: string,) => {




  return `/admin/v1/agents/${agentID}`
}

/**
 * Permanently deletes the server record and every virtual node currently
 * assigned to it, including node access projections, runtime sessions,
 * legacy plan references, assignments, and agent credentials. Host-side
 * adapter files are not removed automatically.
 * @summary Delete an adapter agent and its assigned virtual nodes.
 */
export const deleteAgent = async (agentID: string, options?: Parameters<typeof request>[1]): Promise<void> => {

  return request<void>(getDeleteAgentUrl(agentID),
  {
    ...options,
    method: 'DELETE'


  }
);}



export const getCreateManagedNodeOnAgentUrl = (agentID: string,) => {




  return `/admin/v1/agents/${agentID}/nodes`
}

/**
 * Provisions a managed inbound and assigns it to the Agent. The existing
 * Agent installation receives the new node through its manifest; no new
 * install token or install script is created.
 * @summary Create a managed virtual node on an existing adapter agent/server.
 */
export const createManagedNodeOnAgent = async (agentID: string,
    agentManagedNodeCreateRequest: AgentManagedNodeCreateRequest, options?: Parameters<typeof request>[1]): Promise<AgentManagedNodeCreateResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<AgentManagedNodeCreateResult>(getCreateManagedNodeOnAgentUrl(agentID),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(agentManagedNodeCreateRequest)
  }
);}



export const getListAgentAssignmentsUrl = (agentID: string,) => {




  return `/admin/v1/agents/${agentID}/assignments`
}

/**
 * @summary List active node assignments for an adapter agent.
 */
export const listAgentAssignments = async (agentID: string, options?: Parameters<typeof request>[1]): Promise<AgentAssignment[]> => {

  return request<AgentAssignment[]>(getListAgentAssignmentsUrl(agentID),
  {
    ...options,
    method: 'GET'


  }
);}



export const getUnassignAgentNodeUrl = (agentID: string,
    nodeID: string,) => {




  return `/admin/v1/agents/${agentID}/nodes/${nodeID}/unassign`
}

/**
 * @summary Drain one virtual node from an adapter agent without deleting it.
 */
export const unassignAgentNode = async (agentID: string,
    nodeID: string,
    agentUnassignNodeRequest: AgentUnassignNodeRequest, options?: Parameters<typeof request>[1]): Promise<AgentAssignmentResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<AgentAssignmentResult>(getUnassignAgentNodeUrl(agentID,nodeID),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(agentUnassignNodeRequest)
  }
);}



export const getReassignAgentNodeUrl = () => {




  return `/admin/v1/agents/reassign`
}

/**
 * @summary Reassign one virtual node between Agents with revision checks.
 */
export const reassignAgentNode = async (agentReassignNodeRequest: AgentReassignNodeRequest, options?: Parameters<typeof request>[1]): Promise<AgentAssignmentResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<AgentAssignmentResult>(getReassignAgentNodeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(agentReassignNodeRequest)
  }
);}



export const getCreateAgentProvisioningBundleUrl = () => {




  return `/admin/v1/agents/provisioning-bundles`
}

/**
 * @summary Create an adapter agent and return its one-time install bundle.
 */
export const createAgentProvisioningBundle = async (agentCreateRequest: AgentCreateRequest, options?: Parameters<typeof request>[1]): Promise<AgentProvisioningBundleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<AgentProvisioningBundleResponse>(getCreateAgentProvisioningBundleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(agentCreateRequest)
  }
);}



export const getIssueAgentProvisioningBundleUrl = (agentID: string,) => {




  return `/admin/v1/agents/${agentID}/provisioning-bundles`
}

/**
 * @summary Issue an install bundle for an existing adapter agent.
 */
export const issueAgentProvisioningBundle = async (agentID: string, options?: Parameters<typeof request>[1]): Promise<AgentProvisioningBundleResponse> => {

  return request<AgentProvisioningBundleResponse>(getIssueAgentProvisioningBundleUrl(agentID),
  {
    ...options,
    method: 'POST'


  }
);}



export const getReissueAgentProvisioningBundleUrl = (agentID: string,) => {




  return `/admin/v1/agents/${agentID}/provisioning-bundles/reissue`
}

/**
 * @summary Reissue a fresh one-time install bundle for an existing adapter agent.
 */
export const reissueAgentProvisioningBundle = async (agentID: string, options?: Parameters<typeof request>[1]): Promise<AgentProvisioningBundleResponse> => {

  return request<AgentProvisioningBundleResponse>(getReissueAgentProvisioningBundleUrl(agentID),
  {
    ...options,
    method: 'POST'


  }
);}



export const getListAgentTokensUrl = (agentID: string,) => {




  return `/admin/v1/agents/${agentID}/tokens`
}

/**
 * @summary List redacted agent-token metadata.
 */
export const listAgentTokens = async (agentID: string, options?: Parameters<typeof request>[1]): Promise<AgentTokenMetadata[]> => {

  return request<AgentTokenMetadata[]>(getListAgentTokensUrl(agentID),
  {
    ...options,
    method: 'GET'


  }
);}



export const getCreateAgentTokenUrl = (agentID: string,) => {




  return `/admin/v1/agents/${agentID}/tokens`
}

/**
 * @summary Issue an agent token and return its plaintext once.
 */
export const createAgentToken = async (agentID: string,
    agentTokenCreateRequest: AgentTokenCreateRequest, options?: Parameters<typeof request>[1]): Promise<AgentTokenWithSecret> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<AgentTokenWithSecret>(getCreateAgentTokenUrl(agentID),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(agentTokenCreateRequest)
  }
);}



export const getRotateAgentTokenUrl = (agentID: string,
    tokenID: string,) => {




  return `/admin/v1/agents/${agentID}/tokens/${tokenID}/rotate`
}

/**
 * @summary Rotate an active agent token and return replacement plaintext once.
 */
export const rotateAgentToken = async (agentID: string,
    tokenID: string, options?: Parameters<typeof request>[1]): Promise<AgentTokenWithSecret> => {

  return request<AgentTokenWithSecret>(getRotateAgentTokenUrl(agentID,tokenID),
  {
    ...options,
    method: 'POST'


  }
);}



export const getRevokeAgentTokenUrl = (agentID: string,
    tokenID: string,) => {




  return `/admin/v1/agents/${agentID}/tokens/${tokenID}/revoke`
}

/**
 * @summary Revoke an agent token.
 */
export const revokeAgentToken = async (agentID: string,
    tokenID: string, options?: Parameters<typeof request>[1]): Promise<void> => {

  return request<void>(getRevokeAgentTokenUrl(agentID,tokenID),
  {
    ...options,
    method: 'POST'


  }
);}



export const getDeleteAgentTokenUrl = (agentID: string,
    tokenID: string,) => {




  return `/admin/v1/agents/${agentID}/tokens/${tokenID}`
}

/**
 * @summary Permanently delete a revoked agent token.
 */
export const deleteAgentToken = async (agentID: string,
    tokenID: string, options?: Parameters<typeof request>[1]): Promise<void> => {

  return request<void>(getDeleteAgentTokenUrl(agentID,tokenID),
  {
    ...options,
    method: 'DELETE'


  }
);}



export const getPreviewAgentMigrationUrl = () => {




  return `/admin/v1/agents/migrations/preview`
}

/**
 * @summary Validate an explicit node-to-agent migration mapping without mutation.
 */
export const previewAgentMigration = async (agentMigrationPreviewRequest: AgentMigrationPreviewRequest, options?: Parameters<typeof request>[1]): Promise<AgentMigrationPreview> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<AgentMigrationPreview>(getPreviewAgentMigrationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(agentMigrationPreviewRequest)
  }
);}



export const getApplyAgentMigrationUrl = () => {




  return `/admin/v1/agents/migrations/apply`
}

/**
 * Applies the previewed mapping only after target Agent readiness checks and optimistic manifest revision validation.
 * @summary Apply a previously previewed explicit migration mapping.
 */
export const applyAgentMigration = async (agentMigrationApplyRequest: AgentMigrationApplyRequest, options?: Parameters<typeof request>[1]): Promise<AgentMigrationResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<AgentMigrationResult>(getApplyAgentMigrationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(agentMigrationApplyRequest)
  }
);}



export const getGenerateEnrollmentTokenUrl = () => {




  return `/admin/v1/enrollment-tokens`
}

/**
 * @summary Generate a single-use enrollment token.
 */
export const generateEnrollmentToken = async (enrollmentTokenCreateRequest: EnrollmentTokenCreateRequest, options?: Parameters<typeof request>[1]): Promise<IssuedEnrollmentToken> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<IssuedEnrollmentToken>(getGenerateEnrollmentTokenUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(enrollmentTokenCreateRequest)
  }
);}



export const getVerifyEnrollmentTokenUrl = () => {




  return `/admin/v1/enrollment-tokens/verify`
}

/**
 * @summary Verify an enrollment token without consuming it.
 */
export const verifyEnrollmentToken = async (enrollmentTokenActionRequest: EnrollmentTokenActionRequest, options?: Parameters<typeof request>[1]): Promise<EnrollmentToken> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<EnrollmentToken>(getVerifyEnrollmentTokenUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(enrollmentTokenActionRequest)
  }
);}



export const getConsumeEnrollmentTokenUrl = () => {




  return `/admin/v1/enrollment-tokens/consume`
}

/**
 * @summary Consume an enrollment token.
 */
export const consumeEnrollmentToken = async (enrollmentTokenActionRequest: EnrollmentTokenActionRequest, options?: Parameters<typeof request>[1]): Promise<EnrollmentToken> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<EnrollmentToken>(getConsumeEnrollmentTokenUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(enrollmentTokenActionRequest)
  }
);}



export const getListGlobalNodeGroupsUrl = () => {




  return `/admin/v1/node-groups`
}

/**
 * @summary List global node groups.
 */
export const listGlobalNodeGroups = async ( options?: Parameters<typeof request>[1]): Promise<GlobalNodeGroup[]> => {

  return request<GlobalNodeGroup[]>(getListGlobalNodeGroupsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getCreateGlobalNodeGroupUrl = () => {




  return `/admin/v1/node-groups`
}

/**
 * @summary Create a global node group.
 */
export const createGlobalNodeGroup = async (globalNodeGroupUpsertRequest: GlobalNodeGroupUpsertRequest, options?: Parameters<typeof request>[1]): Promise<GlobalNodeGroup> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<GlobalNodeGroup>(getCreateGlobalNodeGroupUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(globalNodeGroupUpsertRequest)
  }
);}



export const getGetGlobalNodeGroupUrl = (groupID: string,) => {




  return `/admin/v1/node-groups/${groupID}`
}

/**
 * @summary Fetch one global node group.
 */
export const getGlobalNodeGroup = async (groupID: string, options?: Parameters<typeof request>[1]): Promise<GlobalNodeGroup> => {

  return request<GlobalNodeGroup>(getGetGlobalNodeGroupUrl(groupID),
  {
    ...options,
    method: 'GET'


  }
);}



export const getUpdateGlobalNodeGroupUrl = (groupID: string,) => {




  return `/admin/v1/node-groups/${groupID}`
}

/**
 * @summary Update a global node group.
 */
export const updateGlobalNodeGroup = async (groupID: string,
    globalNodeGroupUpsertRequest: GlobalNodeGroupUpsertRequest, options?: Parameters<typeof request>[1]): Promise<GlobalNodeGroup> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<GlobalNodeGroup>(getUpdateGlobalNodeGroupUrl(groupID),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(globalNodeGroupUpsertRequest)
  }
);}



export const getDeleteGlobalNodeGroupUrl = (groupID: string,) => {




  return `/admin/v1/node-groups/${groupID}`
}

/**
 * @summary Delete a global node group.
 */
export const deleteGlobalNodeGroup = async (groupID: string, options?: Parameters<typeof request>[1]): Promise<void> => {

  return request<void>(getDeleteGlobalNodeGroupUrl(groupID),
  {
    ...options,
    method: 'DELETE'


  }
);}



export const getListGlobalNodeGroupMembersUrl = (groupID: string,) => {




  return `/admin/v1/node-groups/${groupID}/members`
}

/**
 * @summary List global node-group members.
 */
export const listGlobalNodeGroupMembers = async (groupID: string, options?: Parameters<typeof request>[1]): Promise<GlobalNodeGroupMember[]> => {

  return request<GlobalNodeGroupMember[]>(getListGlobalNodeGroupMembersUrl(groupID),
  {
    ...options,
    method: 'GET'


  }
);}



export const getAddGlobalNodeGroupMemberUrl = (groupID: string,) => {




  return `/admin/v1/node-groups/${groupID}/members`
}

/**
 * @summary Add a node to a global node group.
 */
export const addGlobalNodeGroupMember = async (groupID: string,
    addGlobalNodeGroupMemberRequest: AddGlobalNodeGroupMemberRequest, options?: Parameters<typeof request>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<void>(getAddGlobalNodeGroupMemberUrl(groupID),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addGlobalNodeGroupMemberRequest)
  }
);}



export const getUpdateGlobalNodeGroupMemberUrl = (groupID: string,
    nodeID: string,) => {




  return `/admin/v1/node-groups/${groupID}/members/${nodeID}`
}

/**
 * @summary Update billing metadata for a global node-group member.
 */
export const updateGlobalNodeGroupMember = async (groupID: string,
    nodeID: string,
    updateGlobalNodeGroupMemberRequest: UpdateGlobalNodeGroupMemberRequest, options?: Parameters<typeof request>[1]): Promise<GlobalNodeGroupMember> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<GlobalNodeGroupMember>(getUpdateGlobalNodeGroupMemberUrl(groupID,nodeID),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateGlobalNodeGroupMemberRequest)
  }
);}



export const getRemoveGlobalNodeGroupMemberUrl = (groupID: string,
    nodeID: string,) => {




  return `/admin/v1/node-groups/${groupID}/members/${nodeID}`
}

/**
 * @summary Remove a node from a global node group.
 */
export const removeGlobalNodeGroupMember = async (groupID: string,
    nodeID: string, options?: Parameters<typeof request>[1]): Promise<void> => {

  return request<void>(getRemoveGlobalNodeGroupMemberUrl(groupID,nodeID),
  {
    ...options,
    method: 'DELETE'


  }
);}



export const getListGrantsUrl = (params?: ListGrantsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/v1/grants?${stringifiedParams}` : `/admin/v1/grants`
}

/**
 * Returns active grants by default. Hard/soft revoked grants are retained for epoch history but omitted unless include_revoked=true.
 * @summary List grants with optional tenant and node filters.
 */
export const listGrants = async (params?: ListGrantsParams, options?: Parameters<typeof request>[1]): Promise<Grant[]> => {

  return request<Grant[]>(getListGrantsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export const getCreateGrantUrl = () => {




  return `/admin/v1/grants`
}

/**
 * @summary Create a tenant grant for a node.
 */
export const createGrant = async (createGrantRequest: CreateGrantRequest, options?: Parameters<typeof request>[1]): Promise<Grant> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<Grant>(getCreateGrantUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createGrantRequest)
  }
);}



export const getUpdateGrantUrl = (grantID: string,) => {




  return `/admin/v1/grants/${grantID}`
}

/**
 * @summary Revoke a grant now (hard or soft) or schedule its revocation (scheduled with revoke_at).
 */
export const updateGrant = async (grantID: string,
    updateGrantRequest: UpdateGrantRequest, options?: Parameters<typeof request>[1]): Promise<Grant> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<Grant>(getUpdateGrantUrl(grantID),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateGrantRequest)
  }
);}



export const getDeleteGrantUrl = (grantID: string,) => {




  return `/admin/v1/grants/${grantID}`
}

/**
 * @summary Hard-revoke a grant.
 */
export const deleteGrant = async (grantID: string, options?: Parameters<typeof request>[1]): Promise<Grant> => {

  return request<Grant>(getDeleteGrantUrl(grantID),
  {
    ...options,
    method: 'DELETE'


  }
);}



export const getCreateSecurityDenyUrl = () => {




  return `/admin/v1/security-denies`
}

/**
 * @summary Create a security deny for a tenant/inbound pair.
 */
export const createSecurityDeny = async (createSecurityDenyRequest: CreateSecurityDenyRequest, options?: Parameters<typeof request>[1]): Promise<SecurityDeny> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<SecurityDeny>(getCreateSecurityDenyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createSecurityDenyRequest)
  }
);}



export const getUpdateSecurityDenyUrl = (denyID: string,) => {




  return `/admin/v1/security-denies/${denyID}`
}

/**
 * @summary Update a security deny window or reason.
 */
export const updateSecurityDeny = async (denyID: string,
    updateSecurityDenyRequest: UpdateSecurityDenyRequest, options?: Parameters<typeof request>[1]): Promise<SecurityDeny> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<SecurityDeny>(getUpdateSecurityDenyUrl(denyID),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateSecurityDenyRequest)
  }
);}



export const getDeleteSecurityDenyUrl = (denyID: string,) => {




  return `/admin/v1/security-denies/${denyID}`
}

/**
 * @summary Delete a security deny.
 */
export const deleteSecurityDeny = async (denyID: string, options?: Parameters<typeof request>[1]): Promise<void> => {

  return request<void>(getDeleteSecurityDenyUrl(denyID),
  {
    ...options,
    method: 'DELETE'


  }
);}



export const getListTenantNodeGroupsUrl = () => {




  return `/api/v1/node-groups`
}

/**
 * @summary List tenant node groups.
 */
export const listTenantNodeGroups = async ( options?: Parameters<typeof request>[1]): Promise<TenantNodeGroupView[]> => {

  return request<TenantNodeGroupView[]>(getListTenantNodeGroupsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getCreateTenantNodeGroupUrl = () => {




  return `/api/v1/node-groups`
}

/**
 * @summary Create a tenant node group.
 */
export const createTenantNodeGroup = async (createTenantNodeGroupRequest: CreateTenantNodeGroupRequest, options?: Parameters<typeof request>[1]): Promise<TenantNodeGroup> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<TenantNodeGroup>(getCreateTenantNodeGroupUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createTenantNodeGroupRequest)
  }
);}



export const getDeleteTenantNodeGroupUrl = (groupID: string,) => {




  return `/api/v1/node-groups/${groupID}`
}

/**
 * @summary Delete a tenant node group.
 */
export const deleteTenantNodeGroup = async (groupID: string, options?: Parameters<typeof request>[1]): Promise<void> => {

  return request<void>(getDeleteTenantNodeGroupUrl(groupID),
  {
    ...options,
    method: 'DELETE'


  }
);}



export const getListAvailableNodesUrl = () => {




  return `/api/v1/inbound-selections/available`
}

/**
 * @summary List nodes currently granted to the tenant, including freshness timestamps.
 */
export const listAvailableNodes = async ( options?: Parameters<typeof request>[1]): Promise<AvailableNode[]> => {

  return request<AvailableNode[]>(getListAvailableNodesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getListTenantPackagesUrl = () => {




  return `/api/v1/packages`
}

/**
 * @summary List the authenticated tenant administrator's active distribution packages.
 */
export const listTenantPackages = async ( options?: Parameters<typeof request>[1]): Promise<Package[]> => {

  return request<Package[]>(getListTenantPackagesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getGetTenantDistributionEntitlementUrl = () => {




  return `/api/v1/distribution-entitlement`
}

/**
 * @summary Read the authenticated tenant administrator's upstream package and distributable nodes.
 */
export const getTenantDistributionEntitlement = async ( options?: Parameters<typeof request>[1]): Promise<TenantDistributionEntitlement> => {

  return request<TenantDistributionEntitlement>(getGetTenantDistributionEntitlementUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getListTenantDistributionPackagesUrl = () => {




  return `/api/v1/distribution-packages`
}

/**
 * @summary List distribution packages owned by the authenticated tenant administrator.
 */
export const listTenantDistributionPackages = async ( options?: Parameters<typeof request>[1]): Promise<Package[]> => {

  return request<Package[]>(getListTenantDistributionPackagesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getCreateTenantDistributionPackageUrl = () => {




  return `/api/v1/distribution-packages`
}

/**
 * @summary Create a draft distribution package from a subset of the upstream nodes.
 */
export const createTenantDistributionPackage = async (tenantPackageRequest: TenantPackageRequest, options?: Parameters<typeof request>[1]): Promise<PackageDetail> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<PackageDetail>(getCreateTenantDistributionPackageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(tenantPackageRequest)
  }
);}



export const getGetTenantDistributionPackageUrl = (packageID: string,) => {




  return `/api/v1/distribution-packages/${packageID}`
}

/**
 * @summary Read an owned tenant distribution package.
 */
export const getTenantDistributionPackage = async (packageID: string, options?: Parameters<typeof request>[1]): Promise<PackageDetail> => {

  return request<PackageDetail>(getGetTenantDistributionPackageUrl(packageID),
  {
    ...options,
    method: 'GET'


  }
);}



export const getUpdateTenantDistributionPackageUrl = (packageID: string,) => {




  return `/api/v1/distribution-packages/${packageID}`
}

/**
 * @summary Update an owned distribution package without changing existing child snapshots.
 */
export const updateTenantDistributionPackage = async (packageID: string,
    tenantPackageRequest: TenantPackageRequest, options?: Parameters<typeof request>[1]): Promise<PackageDetail> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<PackageDetail>(getUpdateTenantDistributionPackageUrl(packageID),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(tenantPackageRequest)
  }
);}



export const getDeleteTenantDistributionPackageUrl = (packageID: string,) => {




  return `/api/v1/distribution-packages/${packageID}`
}

/**
 * @summary Delete an unused owned distribution package.
 */
export const deleteTenantDistributionPackage = async (packageID: string, options?: Parameters<typeof request>[1]): Promise<void> => {

  return request<void>(getDeleteTenantDistributionPackageUrl(packageID),
  {
    ...options,
    method: 'DELETE'


  }
);}



export const getPublishTenantDistributionPackageUrl = (packageID: string,) => {




  return `/api/v1/distribution-packages/${packageID}/publish`
}

/**
 * @summary Publish an owned draft distribution package.
 */
export const publishTenantDistributionPackage = async (packageID: string, options?: Parameters<typeof request>[1]): Promise<PublishedPackageDetail> => {

  return request<PublishedPackageDetail>(getPublishTenantDistributionPackageUrl(packageID),
  {
    ...options,
    method: 'POST'


  }
);}



export const getApplyTenantDistributionPackageUrl = (packageID: string,) => {




  return `/api/v1/distribution-packages/${packageID}/apply`
}

/**
 * @summary Rebuild existing child subscription snapshots from the current package definition.
 */
export const applyTenantDistributionPackage = async (packageID: string, options?: Parameters<typeof request>[1]): Promise<ApplyTenantDistributionPackage200> => {

  return request<ApplyTenantDistributionPackage200>(getApplyTenantDistributionPackageUrl(packageID),
  {
    ...options,
    method: 'POST'


  }
);}



export const getArchiveTenantDistributionPackageUrl = (packageID: string,) => {




  return `/api/v1/distribution-packages/${packageID}/archive`
}

/**
 * @summary Archive an owned distribution package.
 */
export const archiveTenantDistributionPackage = async (packageID: string, options?: Parameters<typeof request>[1]): Promise<PackageDetail> => {

  return request<PackageDetail>(getArchiveTenantDistributionPackageUrl(packageID),
  {
    ...options,
    method: 'POST'


  }
);}



export const getReplaceInboundSelectionsUrl = () => {




  return `/api/v1/inbound-selections`
}

/**
 * @summary Replace inbound selections for a tenant node group.
 */
export const replaceInboundSelections = async (replaceInboundSelectionsRequest: ReplaceInboundSelectionsRequest, options?: Parameters<typeof request>[1]): Promise<TenantNodeGroupMember[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<TenantNodeGroupMember[]>(getReplaceInboundSelectionsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(replaceInboundSelectionsRequest)
  }
);}



export const getListPackagesUrl = () => {




  return `/admin/v1/packages`
}

/**
 * @summary List billing packages.
 */
export const listPackages = async ( options?: Parameters<typeof request>[1]): Promise<Package[]> => {

  return request<Package[]>(getListPackagesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getCreatePackageUrl = () => {




  return `/admin/v1/packages`
}

/**
 * @summary Create a billing package.
 */
export const createPackage = async (packageRequest: PackageRequest, options?: Parameters<typeof request>[1]): Promise<PackageDetail> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<PackageDetail>(getCreatePackageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(packageRequest)
  }
);}



export const getGetPackageUrl = (packageID: string,) => {




  return `/admin/v1/packages/${packageID}`
}

/**
 * @summary Fetch one billing package with its node-group links.
 */
export const getPackage = async (packageID: string, options?: Parameters<typeof request>[1]): Promise<PackageDetail> => {

  return request<PackageDetail>(getGetPackageUrl(packageID),
  {
    ...options,
    method: 'GET'


  }
);}



export const getUpdatePackageUrl = (packageID: string,) => {




  return `/admin/v1/packages/${packageID}`
}

/**
 * @summary Update a billing package with If-Match concurrency.
 */
export const updatePackage = async (packageID: string,
    packageRequest: PackageRequest, options?: Parameters<typeof request>[1]): Promise<PackageDetail> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<PackageDetail>(getUpdatePackageUrl(packageID),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(packageRequest)
  }
);}



export const getDeletePackageUrl = (packageID: string,) => {




  return `/admin/v1/packages/${packageID}`
}

/**
 * Physically removes a package. When the package is still referenced
 * by a non-terminal subscription (`subscriptions.package_id` or
 * `subscription_package_snapshots` for statuses other than
 * cancelled/expired) the call returns a 409 conflict envelope whose
 * `details` payload names the blocking tables. Terminal subscription
 * history is cleared as part of the delete. Archive the package
 * first (POST `/admin/v1/packages/{packageID}/archive`) when live
 * subscriptions still use it.
 * @summary Hard-delete a billing package.
 */
export const deletePackage = async (packageID: string, options?: Parameters<typeof request>[1]): Promise<void> => {

  return request<void>(getDeletePackageUrl(packageID),
  {
    ...options,
    method: 'DELETE'


  }
);}



export const getPreviewPackageNodesUrl = (packageID: string,
    params?: PreviewPackageNodesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["node_group_id"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/v1/packages/${packageID}/nodes?${stringifiedParams}` : `/admin/v1/packages/${packageID}/nodes`
}

/**
 * Lists members of the given node groups, deduplicated first group wins as
 * a subscription snapshot does. Without `node_group_id` the package's
 * stored groups are used, so an editor can also preview unsaved groups.
 * External subscription and group external nodes are not listed: they
 * keep their own names.
 * @summary Preview the managed nodes of a package with their subscriber-visible names.
 */
export const previewPackageNodes = async (packageID: string,
    params?: PreviewPackageNodesParams, options?: Parameters<typeof request>[1]): Promise<PackagePreviewNodeList> => {

  return request<PackagePreviewNodeList>(getPreviewPackageNodesUrl(packageID,params),
  {
    ...options,
    method: 'GET'


  }
);}



export const getArchivePackageUrl = (packageID: string,) => {




  return `/admin/v1/packages/${packageID}/archive`
}

/**
 * Flips the package's status to `archived`. This is the reversible,
 * non-conflicting companion to `deletePackage`; subscription
 * history that still references the package is preserved.
 * @summary Archive a billing package.
 */
export const archivePackage = async (packageID: string, options?: Parameters<typeof request>[1]): Promise<PackageDetail> => {

  return request<PackageDetail>(getArchivePackageUrl(packageID),
  {
    ...options,
    method: 'POST'


  }
);}



export const getPublishPackageUrl = (packageID: string,) => {




  return `/admin/v1/packages/${packageID}/publish`
}

/**
 * Runs deterministic membership, credential, rate, and export-shape
 * checks before moving a draft package to active. The package remains
 * draft when any check fails.
 * @summary Publish a draft billing package.
 */
export const publishPackage = async (packageID: string, options?: Parameters<typeof request>[1]): Promise<PublishedPackageDetail> => {

  return request<PublishedPackageDetail>(getPublishPackageUrl(packageID),
  {
    ...options,
    method: 'POST'


  }
);}



export const getListAnnouncementsUrl = (params?: ListAnnouncementsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/v1/announcements?${stringifiedParams}` : `/admin/v1/announcements`
}

/**
 * @summary List platform announcements.
 */
export const listAnnouncements = async (params?: ListAnnouncementsParams, options?: Parameters<typeof request>[1]): Promise<Announcement[]> => {

  return request<Announcement[]>(getListAnnouncementsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export const getCreateAnnouncementUrl = () => {




  return `/admin/v1/announcements`
}

/**
 * @summary Create an announcement draft (optionally publish immediately).
 */
export const createAnnouncement = async (announcementRequest: AnnouncementRequest, options?: Parameters<typeof request>[1]): Promise<Announcement> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<Announcement>(getCreateAnnouncementUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(announcementRequest)
  }
);}



export const getGetAnnouncementUrl = (announcementID: string,) => {




  return `/admin/v1/announcements/${announcementID}`
}

/**
 * @summary Fetch one announcement.
 */
export const getAnnouncement = async (announcementID: string, options?: Parameters<typeof request>[1]): Promise<Announcement> => {

  return request<Announcement>(getGetAnnouncementUrl(announcementID),
  {
    ...options,
    method: 'GET'


  }
);}



export const getUpdateAnnouncementUrl = (announcementID: string,) => {




  return `/admin/v1/announcements/${announcementID}`
}

/**
 * Content edits are allowed in any status, including archived.
 * @summary Update an announcement with If-Match concurrency.
 */
export const updateAnnouncement = async (announcementID: string,
    announcementRequest: AnnouncementRequest, options?: Parameters<typeof request>[1]): Promise<Announcement> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<Announcement>(getUpdateAnnouncementUrl(announcementID),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(announcementRequest)
  }
);}



export const getDeleteAnnouncementUrl = (announcementID: string,) => {




  return `/admin/v1/announcements/${announcementID}`
}

/**
 * Published announcements must be archived before they can be deleted.
 * @summary Hard-delete a draft or archived announcement.
 */
export const deleteAnnouncement = async (announcementID: string, options?: Parameters<typeof request>[1]): Promise<void> => {

  return request<void>(getDeleteAnnouncementUrl(announcementID),
  {
    ...options,
    method: 'DELETE'


  }
);}



export const getPublishAnnouncementUrl = (announcementID: string,) => {




  return `/admin/v1/announcements/${announcementID}/publish`
}

/**
 * @summary Publish a draft or re-publish an archived announcement.
 */
export const publishAnnouncement = async (announcementID: string, options?: Parameters<typeof request>[1]): Promise<Announcement> => {

  return request<Announcement>(getPublishAnnouncementUrl(announcementID),
  {
    ...options,
    method: 'POST'


  }
);}



export const getArchiveAnnouncementUrl = (announcementID: string,) => {




  return `/admin/v1/announcements/${announcementID}/archive`
}

/**
 * @summary Archive an announcement (hide from inboxes).
 */
export const archiveAnnouncement = async (announcementID: string, options?: Parameters<typeof request>[1]): Promise<Announcement> => {

  return request<Announcement>(getArchiveAnnouncementUrl(announcementID),
  {
    ...options,
    method: 'POST'


  }
);}



export const getListAuditLogsUrl = (params?: ListAuditLogsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/v1/audit-logs?${stringifiedParams}` : `/admin/v1/audit-logs`
}

/**
 * @summary List immutable operator audit records.
 */
export const listAuditLogs = async (params?: ListAuditLogsParams, options?: Parameters<typeof request>[1]): Promise<AuditLogList> => {

  return request<AuditLogList>(getListAuditLogsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export const getListCredentialDomainsUrl = () => {




  return `/admin/v1/credential-domains`
}

/**
 * @summary List credential domains.
 */
export const listCredentialDomains = async ( options?: Parameters<typeof request>[1]): Promise<CredentialDomain[]> => {

  return request<CredentialDomain[]>(getListCredentialDomainsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getCreateCredentialDomainUrl = () => {




  return `/admin/v1/credential-domains`
}

/**
 * @summary Create a credential domain.
 */
export const createCredentialDomain = async (credentialDomainRequest: CredentialDomainRequest, options?: Parameters<typeof request>[1]): Promise<CredentialDomain> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<CredentialDomain>(getCreateCredentialDomainUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(credentialDomainRequest)
  }
);}



export const getListSubscriptionsUrl = () => {




  return `/api/v1/subscriptions`
}

/**
 * @summary List tenant subscription summaries.
 */
export const listSubscriptions = async ( options?: Parameters<typeof request>[1]): Promise<SubscriptionSummary[]> => {

  return request<SubscriptionSummary[]>(getListSubscriptionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getCreateManagedSubscriptionUrl = () => {




  return `/api/v1/subscriptions`
}

/**
 * Reassigning an active user preserves current subscription-link identity and node credentials while replacing package-derived access.
 * @summary Assign a package and provision its subscription access.
 */
export const createManagedSubscription = async (createManagedSubscriptionRequest: CreateManagedSubscriptionRequest, options?: Parameters<typeof request>[1]): Promise<ManagedSubscription> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<ManagedSubscription>(getCreateManagedSubscriptionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createManagedSubscriptionRequest)
  }
);}



export const getListUserCredentialsUrl = (userID: Uuid,) => {




  return `/api/v1/users/${userID}/credentials`
}

/**
 * @summary List tenant user credentials.
 */
export const listUserCredentials = async (userID: Uuid, options?: Parameters<typeof request>[1]): Promise<UserCredential[]> => {

  return request<UserCredential[]>(getListUserCredentialsUrl(userID),
  {
    ...options,
    method: 'GET'


  }
);}



export const getCreateUserCredentialUrl = (userID: Uuid,) => {




  return `/api/v1/users/${userID}/credentials`
}

/**
 * An existing credential cannot be replaced here; rotate it through the user or administrator subscription-reset endpoint.
 * @summary Create a tenant user's initial credential for a credential domain.
 */
export const createUserCredential = async (userID: Uuid,
    createUserCredentialRequest: CreateUserCredentialRequest, options?: Parameters<typeof request>[1]): Promise<UserCredential> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<UserCredential>(getCreateUserCredentialUrl(userID),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createUserCredentialRequest)
  }
);}



export const getGetTenantUserAccessUrl = (tenantId: string,
    userId: string,) => {




  return `/api/v1/tenants/${tenantId}/users/${userId}/access`
}

/**
 * @summary Read subscription links, passwords, usage, and expiry for a tenant user.
 */
export const getTenantUserAccess = async (tenantId: string,
    userId: string, options?: Parameters<typeof request>[1]): Promise<UserAccess> => {

  return request<UserAccess>(getGetTenantUserAccessUrl(tenantId,userId),
  {
    ...options,
    method: 'GET'


  }
);}



export const getResetTenantUserSubscriptionUrl = (tenantId: string,
    userId: string,) => {




  return `/api/v1/tenants/${tenantId}/users/${userId}/subscription/reset`
}

/**
 * @summary Rotate a tenant user's subscription links and node credentials.
 */
export const resetTenantUserSubscription = async (tenantId: string,
    userId: string, options?: Parameters<typeof request>[1]): Promise<UserAccess> => {

  return request<UserAccess>(getResetTenantUserSubscriptionUrl(tenantId,userId),
  {
    ...options,
    method: 'POST'


  }
);}



export const getResetTenantUserTrafficUrl = (tenantId: string,
    userId: string,) => {




  return `/api/v1/tenants/${tenantId}/users/${userId}/traffic/reset`
}

/**
 * @summary Reset a tenant user's current billable traffic period.
 */
export const resetTenantUserTraffic = async (tenantId: string,
    userId: string, options?: Parameters<typeof request>[1]): Promise<void> => {

  return request<void>(getResetTenantUserTrafficUrl(tenantId,userId),
  {
    ...options,
    method: 'POST'


  }
);}



export const getListSubscriptionLinksUrl = () => {




  return `/api/v1/subscription-links`
}

/**
 * @summary List subscription links for the tenant.
 */
export const listSubscriptionLinks = async ( options?: Parameters<typeof request>[1]): Promise<SubscriptionLink[]> => {

  return request<SubscriptionLink[]>(getListSubscriptionLinksUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getCreateSubscriptionLinkUrl = () => {




  return `/api/v1/subscription-links`
}

/**
 * @summary Issue an additional subscription link.
 */
export const createSubscriptionLink = async (createSubscriptionLinkRequest: CreateSubscriptionLinkRequest, options?: Parameters<typeof request>[1]): Promise<SubscriptionLink> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<SubscriptionLink>(getCreateSubscriptionLinkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createSubscriptionLinkRequest)
  }
);}



export const getPatchSubscriptionLinkUrl = (linkID: string,) => {




  return `/api/v1/subscription-links/${linkID}`
}

/**
 * @summary Patch subscription link metadata or status.
 */
export const patchSubscriptionLink = async (linkID: string,
    patchSubscriptionLinkRequest: PatchSubscriptionLinkRequest, options?: Parameters<typeof request>[1]): Promise<SubscriptionLink> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<SubscriptionLink>(getPatchSubscriptionLinkUrl(linkID),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchSubscriptionLinkRequest)
  }
);}



export const getDeleteSubscriptionLinkUrl = (linkID: string,) => {




  return `/api/v1/subscription-links/${linkID}`
}

/**
 * @summary Delete a subscription link.
 */
export const deleteSubscriptionLink = async (linkID: string, options?: Parameters<typeof request>[1]): Promise<void> => {

  return request<void>(getDeleteSubscriptionLinkUrl(linkID),
  {
    ...options,
    method: 'DELETE'


  }
);}



export const getRotateSubscriptionLinkSecretUrl = (linkID: string,) => {




  return `/api/v1/subscription-links/${linkID}/rotate-secret`
}

/**
 * @summary Rotate a subscription link secret.
 */
export const rotateSubscriptionLinkSecret = async (linkID: string, options?: Parameters<typeof request>[1]): Promise<SubscriptionLink> => {

  return request<SubscriptionLink>(getRotateSubscriptionLinkSecretUrl(linkID),
  {
    ...options,
    method: 'POST'


  }
);}



export const getGetSubscriptionConfigUrl = (link: string,
    params?: GetSubscriptionConfigParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sub/${link}?${stringifiedParams}` : `/sub/${link}`
}

/**
 * The singbox format returns a complete client configuration with a TUN
 * inbound, Cloudflare DNS, daily remote rule sets, domestic/Apple direct
 * routing, and one proxy selector containing the authorized managed
 * Hysteria2/AnyTLS/Shadowsocks nodes plus direct. Remote rules use the proxy HTTP client.
 * It requires sing-box 1.14 HTTP client fields, validated with the product
 * sing-box-fb testing core. Explicit format overrides
 * client detection; sing-box User-Agents default to singbox. The existing
 * json format continues to return VisibleSubscriptionConfig.
 * Unsupported selected protocols/external nodes return validation_failed;
 * no nodes after address selection returns not_found. Existing link,
 * user, subscription, credential, and online-node checks apply unchanged.
 * @summary Resolve a public subscription link into a visible runtime config.
 */
export const getSubscriptionConfig = async (link: string,
    params?: GetSubscriptionConfigParams, options?: Parameters<typeof request>[1]): Promise<VisibleSubscriptionConfig | SingBoxSubscriptionConfig | string> => {

  return request<VisibleSubscriptionConfig | SingBoxSubscriptionConfig | string>(getGetSubscriptionConfigUrl(link,params),
  {
    ...options,
    method: 'GET'


  }
);}



export const getFetchManifestUrl = () => {




  return `/internal/v1/node/manifest`
}

/**
 * @summary Fetch current manifest and lease for a node
 */
export const fetchManifest = async ( options?: Parameters<typeof request>[1]): Promise<ManifestResponse> => {

  return request<ManifestResponse>(getFetchManifestUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export const getAcknowledgeManifestUrl = () => {




  return `/internal/v1/node/manifest/ack`
}

/**
 * @summary Acknowledge a manifest generation
 */
export const acknowledgeManifest = async (ackManifestRequest: AckManifestRequest, options?: Parameters<typeof request>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<void>(getAcknowledgeManifestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(ackManifestRequest)
  }
);}



export const getManifestHeartbeatUrl = () => {




  return `/internal/v1/node/manifest/heartbeat`
}

/**
 * @summary Renew manifest lease
 */
export const manifestHeartbeat = async (heartbeatRequest: HeartbeatRequest, options?: Parameters<typeof request>[1]): Promise<LeaseGrant> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<LeaseGrant>(getManifestHeartbeatUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(heartbeatRequest)
  }
);}



export const getCloseBootSessionUrl = () => {




  return `/internal/v1/node/boot/close`
}

/**
 * @summary Close a boot session
 */
export const closeBootSession = async (closeBootSessionRequest: CloseBootSessionRequest, options?: Parameters<typeof request>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<void>(getCloseBootSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(closeBootSessionRequest)
  }
);}



export const getIngestUsageReportUrl = () => {




  return `/internal/v1/node/usage-reports`
}

/**
 * @summary Ingest a signed usage report from a node
 */
export const ingestUsageReport = async (usageReportIngestRequest: UsageReportIngestRequest, options?: Parameters<typeof request>[1]): Promise<IngestResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<IngestResponse>(getIngestUsageReportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(usageReportIngestRequest)
  }
);}



export const getListTenantUsageUrl = (tenantId: TenantID,
    params?: ListTenantUsageParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/tenants/${tenantId}/usage?${stringifiedParams}` : `/api/v1/tenants/${tenantId}/usage`
}

/**
 * @summary List usage rollups for a tenant
 */
export const listTenantUsage = async (tenantId: TenantID,
    params?: ListTenantUsageParams, options?: Parameters<typeof request>[1]): Promise<UsageRollupList> => {

  return request<UsageRollupList>(getListTenantUsageUrl(tenantId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export const getGetTenantTrafficUrl = (tenantId: string,
    params?: GetTenantTrafficParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/tenants/${tenantId}/traffic?${stringifiedParams}` : `/api/v1/tenants/${tenantId}/traffic`
}

/**
 * @summary Return raw hourly traffic history inside the authenticated tenant.
 */
export const getTenantTraffic = async (tenantId: string,
    params?: GetTenantTrafficParams, options?: Parameters<typeof request>[1]): Promise<TrafficHistory> => {

  return request<TrafficHistory>(getGetTenantTrafficUrl(tenantId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export const getGetTenantTrafficRankingsUrl = (tenantId: string,
    params: GetTenantTrafficRankingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/tenants/${tenantId}/traffic/rankings?${stringifiedParams}` : `/api/v1/tenants/${tenantId}/traffic/rankings`
}

/**
 * @summary Rank users or nodes by raw traffic inside the authenticated tenant.
 */
export const getTenantTrafficRankings = async (tenantId: string,
    params: GetTenantTrafficRankingsParams, options?: Parameters<typeof request>[1]): Promise<TrafficRanking> => {

  return request<TrafficRanking>(getGetTenantTrafficRankingsUrl(tenantId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export const getGetAdminTrafficUrl = (params?: GetAdminTrafficParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/v1/traffic?${stringifiedParams}` : `/admin/v1/traffic`
}

/**
 * @summary Return cross-tenant raw hourly traffic history.
 */
export const getAdminTraffic = async (params?: GetAdminTrafficParams, options?: Parameters<typeof request>[1]): Promise<TrafficHistory> => {

  return request<TrafficHistory>(getGetAdminTrafficUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export const getGetAdminTrafficRankingsUrl = (params: GetAdminTrafficRankingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/v1/traffic/rankings?${stringifiedParams}` : `/admin/v1/traffic/rankings`
}

/**
 * @summary Rank tenants, users, or nodes by raw observed traffic.
 */
export const getAdminTrafficRankings = async (params: GetAdminTrafficRankingsParams, options?: Parameters<typeof request>[1]): Promise<TrafficRanking> => {

  return request<TrafficRanking>(getGetAdminTrafficRankingsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export const getGetAgentAssignmentManifestUrl = (agentId: Uuid,) => {




  return `/api/v1/agents/${agentId}/manifest`
}

/**
 * @summary Get the deterministic assignment manifest for an adapter agent.
 */
export const getAgentAssignmentManifest = async (agentId: Uuid, options?: Parameters<typeof request>[1]): Promise<AgentAssignmentManifest> => {

  return request<AgentAssignmentManifest>(getGetAgentAssignmentManifestUrl(agentId),
  {
    ...options,
    method: 'GET'


  }
);}



export const getPostAgentInstallReportUrl = (agentId: Uuid,) => {




  return `/api/v1/agents/${agentId}/install-report`
}

/**
 * One-time install report from a freshly provisioned adapter agent.
 * Accepts both pending and active agent credentials (AgentInstallAuthMiddleware).
 * First write returns 201; idempotent re-report with same payload returns 200.
 * Conflicting second report (different addresses) returns 409 CONFLICT.
 * @summary Report adapter-agent install addresses and timestamp.
 */
export const postAgentInstallReport = async (agentId: Uuid,
    agentInstallReportRequest: AgentInstallReportRequest, options?: Parameters<typeof request>[1]): Promise<AgentInstallReportResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<AgentInstallReportResult>(getPostAgentInstallReportUrl(agentId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(agentInstallReportRequest)
  }
);}



export const getPostAgentHeartbeatUrl = (agentId: Uuid,) => {




  return `/api/v1/agents/${agentId}/heartbeats`
}

/**
 * Periodic heartbeat from an active adapter agent.
 * Requires active agent credentials only (AgentAuthMiddleware).
 * Includes adapter version, sing-box version, and per-node inbound statuses.
 * @summary Submit adapter-agent heartbeat with node inbound statuses.
 */
export const postAgentHeartbeat = async (agentId: Uuid,
    agentHeartbeatRequest: AgentHeartbeatRequest, options?: Parameters<typeof request>[1]): Promise<AgentHeartbeatResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<AgentHeartbeatResult>(getPostAgentHeartbeatUrl(agentId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(agentHeartbeatRequest)
  }
);}



export const getGetAdapterConfigurationUrl = (nodeId: Uuid,) => {




  return `/api/v1/nodes/${nodeId}/configuration`
}

/**
 * @summary Get the projected configuration for a virtual node.
 */
export const getAdapterConfiguration = async (nodeId: Uuid, options?: Parameters<typeof request>[1]): Promise<AdapterConfigurationResponse> => {

  return request<AdapterConfigurationResponse>(getGetAdapterConfigurationUrl(nodeId),
  {
    ...options,
    method: 'GET'


  }
);}



export const getGetAdapterUsersUrl = (nodeId: Uuid,
    inboundId: Uuid,) => {




  return `/api/v1/nodes/${nodeId}/inbounds/${inboundId}/users`
}

/**
 * @summary Get the projected user list for a node inbound.
 */
export const getAdapterUsers = async (nodeId: Uuid,
    inboundId: Uuid, options?: Parameters<typeof request>[1]): Promise<AdapterUserSnapshot> => {

  return request<AdapterUserSnapshot>(getGetAdapterUsersUrl(nodeId,inboundId),
  {
    ...options,
    method: 'GET'


  }
);}



export const getPostAdapterTrafficReportUrl = (nodeId: Uuid,) => {




  return `/api/v1/nodes/${nodeId}/traffic-reports`
}

/**
 * @summary Submit a traffic report from an adapter node.
 */
export const postAdapterTrafficReport = async (nodeId: Uuid,
    adapterTrafficReportRequest: AdapterTrafficReportRequest, options?: Parameters<typeof request>[1]): Promise<AdapterTrafficReportResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<AdapterTrafficReportResult>(getPostAdapterTrafficReportUrl(nodeId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adapterTrafficReportRequest)
  }
);}



export const getPostAdapterHeartbeatUrl = (nodeId: Uuid,) => {




  return `/api/v1/nodes/${nodeId}/heartbeats`
}

/**
 * @summary Submit a heartbeat from an adapter node.
 */
export const postAdapterHeartbeat = async (nodeId: Uuid,
    adapterHeartbeatRequest: AdapterHeartbeatRequest, options?: Parameters<typeof request>[1]): Promise<AdapterHeartbeatResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<AdapterHeartbeatResult>(getPostAdapterHeartbeatUrl(nodeId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adapterHeartbeatRequest)
  }
);}



export const getPostAdapterInstallReportUrl = (nodeId: Uuid,) => {




  return `/api/v1/nodes/${nodeId}/install-report`
}

/**
 * @summary Submit a one-shot install report from a freshly provisioned adapter node.
 */
export const postAdapterInstallReport = async (nodeId: Uuid,
    adapterInstallReportRequest: AdapterInstallReportRequest, options?: Parameters<typeof request>[1]): Promise<AdapterInstallReportResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<AdapterInstallReportResult>(getPostAdapterInstallReportUrl(nodeId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adapterInstallReportRequest)
  }
);}



export const getRotateCurrentAdapterTokenUrl = (nodeId: Uuid,) => {




  return `/api/v1/nodes/${nodeId}/adapter-token/rotate`
}

/**
 * Issues a replacement token valid for 30 days. The authenticated token
 * remains valid for a one-hour handoff window so the adapter can persist
 * and activate the replacement before the old token expires.
 * @summary Rotate the bearer token used by the current adapter.
 */
export const rotateCurrentAdapterToken = async (nodeId: Uuid, options?: Parameters<typeof request>[1]): Promise<AdapterTokenRotationResponse> => {

  return request<AdapterTokenRotationResponse>(getRotateCurrentAdapterTokenUrl(nodeId),
  {
    ...options,
    method: 'POST'


  }
);}



export const getCreateAdapterTokenUrl = (nodeID: string,) => {




  return `/admin/v1/nodes/${nodeID}/adapter-tokens`
}

/**
 * @summary Create an adapter token for a node.
 */
export const createAdapterToken = async (nodeID: string,
    createAdapterTokenRequest: CreateAdapterTokenRequest, options?: Parameters<typeof request>[1]): Promise<AdapterTokenWithSecret> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<AdapterTokenWithSecret>(getCreateAdapterTokenUrl(nodeID),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createAdapterTokenRequest)
  }
);}



export const getListAdapterTokensUrl = (nodeID: string,) => {




  return `/admin/v1/nodes/${nodeID}/adapter-tokens`
}

/**
 * @summary List adapter tokens for a node.
 */
export const listAdapterTokens = async (nodeID: string, options?: Parameters<typeof request>[1]): Promise<AdapterTokenMetadata[]> => {

  return request<AdapterTokenMetadata[]>(getListAdapterTokensUrl(nodeID),
  {
    ...options,
    method: 'GET'


  }
);}



export const getRevokeAdapterTokenUrl = (nodeID: string,
    tokenID: string,) => {




  return `/admin/v1/nodes/${nodeID}/adapter-tokens/${tokenID}/revoke`
}

/**
 * @summary Revoke an adapter token.
 */
export const revokeAdapterToken = async (nodeID: string,
    tokenID: string, options?: Parameters<typeof request>[1]): Promise<void> => {

  return request<void>(getRevokeAdapterTokenUrl(nodeID,tokenID),
  {
    ...options,
    method: 'POST'


  }
);}



export const getRotateAdapterTokenUrl = (nodeID: string,
    tokenID: string,) => {




  return `/admin/v1/nodes/${nodeID}/adapter-tokens/${tokenID}/rotate`
}

/**
 * @summary Rotate an adapter token, revoking the old one and returning a new one-time plaintext.
 */
export const rotateAdapterToken = async (nodeID: string,
    tokenID: string,
    rotateAdapterTokenRequest: RotateAdapterTokenRequest, options?: Parameters<typeof request>[1]): Promise<AdapterTokenWithSecret> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return request<AdapterTokenWithSecret>(getRotateAdapterTokenUrl(nodeID,tokenID),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(rotateAdapterTokenRequest)
  }
);}
